function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUiUx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--floor--inject-17",
    d: "M123.68,313c-69.76,40.28-69.75,105.58,0,145.85s182.87,40.28,252.63,0,69.75-105.57,0-145.85S193.44,272.73,123.68,313Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-17"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-17",
    cx: 250.14,
    cy: 394.18,
    rx: 60.54,
    ry: 34.95,
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pencil--inject-17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pencile--inject-17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--pencil--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M312.4,342.18l.56-1.86.69-2.25,35.7-117.29c-1.24.94-4.11,1.1-7.09.31-3.47-.93-6.5-2.87-7-4.67L299.72,333.11l-1.29,4.3C299.42,334.67,313.36,339.42,312.4,342.18Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.65,333.3l-1.24,4.17c-.4,1.2,1.94,2.74,4.83,3.9,3.84,1.55,8.64,2.41,9.18.82l.92-3.07.31-1.1c-.54,1.58-5.34.73-9.18-.82-2.77-1.11-5-2.59-4.85-3.76v0A.18.18,0,0,1,299.65,333.3Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.35,334.35c-.94,2.77,13.06,7.49,14,4.71l1.26-4.16c-.94,2.77-14.94-1.95-14-4.72Z",
    style: {
      fill: "#3E8804"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.81,326.2l-1.25,4.12c-.94,2.72,12.53,7.41,13.93,5a.52.52,0,0,0,.07-.15l1.22-4.15C314.79,333.72,300.85,329,301.81,326.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.4,337.42h0v.06c-.43,1.2,1.93,2.73,4.83,3.89,3.77,1.54,8.48,2.41,9.13.9l-5.24,17.39c-.55,1.43-2,2.06-3.72,2.13-4.67.19-11.56-3.71-10.08-7.55Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.94,203.6c2,.87,2.83.54,2.83.54l.58,16.64c-2,2.14-6.2,2-9.5.48l.23-.79Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.61,199.62l.16,4.52s-.79.4-2.83-.54l1.51-4.33h0a.63.63,0,0,1,.88-.16A.62.62,0,0,1,348.61,199.62Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.24,216.43h0l9.83-13.79a2,2,0,0,0,.88,1l-5.86,16.87-.23.79C337.6,220.22,335.75,218.51,335.24,216.43Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.94,203.6a1.56,1.56,0,0,1-.88-1l2.39-3.35Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.85,221.26,299.33,361.1a11.69,11.69,0,0,0,4.09.68c1.74-.06,3.16-.7,3.72-2.13l5.26-17.47.56-1.86.69-2.25,35.7-117.29C346.81,223.41,341.89,222.32,339.85,221.26Z",
    style: {
      opacity: 0.2
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Brush--inject-17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--brush--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.55,236h0a591.39,591.39,0,0,0,15.64,61c9.55,29.52,25.47,60,28.17,64.57l0,.06,0,.07h0a2.3,2.3,0,0,0,1.76,1.07,2.32,2.32,0,0,0,2.5-2.13,2.24,2.24,0,0,0,0-.52h0s-5-40.22-14.36-69.25-23.07-58.42-23.07-58.42h0a3,3,0,0,0-2.18-1.43,8.84,8.84,0,0,0-7.6,2.46A2.94,2.94,0,0,0,156.55,236Z",
    style: {
      fill: "#3E8804"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.69,360.66a2.24,2.24,0,0,0,0-.52h0s-5-40.22-14.36-69.25c-6.32-19.53-14.57-39.22-19.3-50l-6.4,3.38s39.46,117.81,37.58,118.54A2.32,2.32,0,0,0,204.69,360.66Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.24,232.46h0a3,3,0,0,0-2.18-1.43,8.84,8.84,0,0,0-7.6,2.46,2.94,2.94,0,0,0-.91,2.48h0s.81,4.19,2.3,10.95c4.49,2,10.85,0,12.9-4.2l0-.09C169,236.33,167.24,232.46,167.24,232.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.83,247.5a9.63,9.63,0,0,0,6.91-4.78l0-.09c-2.73-6.3-4.53-10.17-4.53-10.17h0a3,3,0,0,0-2.18-1.43,8.41,8.41,0,0,0-4.67.54Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.41,218.85a27.3,27.3,0,0,0-1-5.95,16.46,16.46,0,0,0-1.06-2.73c-3.17-2-5.13-.11-8.12.74a8.81,8.81,0,0,1-3.21.34c-4.17-.33-4.8-3.74-7.92-4.32s-4.82,4.88-4.84,4.93c0,.59,0,1.18,0,1.78,0,3.84.22,8,3.11,12.74A25,25,0,0,0,156.54,236a14.2,14.2,0,0,0,3.05.13,10.25,10.25,0,0,0,7.65-3.64c.34-1.22.73-2.52,1.09-3.92.09-.35.18-.7.26-1.06.17-.73.33-1.48.46-2.26a28,28,0,0,0,.39-3.68C169.47,220.67,169.47,219.78,169.41,218.85Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.41,218.85a27.3,27.3,0,0,0-1-5.95,16.46,16.46,0,0,0-1.06-2.73,6.16,6.16,0,0,0-1.5-.69c-1.77-.52-3.22.15-4.88.82a16.12,16.12,0,0,1-1.74.61c4,6.91,1,22.12.4,25.19a10.28,10.28,0,0,0,7.65-3.63h0c.15-.54.32-1.11.48-1.69s.41-1.45.61-2.23c.09-.35.18-.7.26-1.06.17-.73.33-1.48.46-2.26,0-.27.08-.57.12-.85a28,28,0,0,0,.27-2.83c0-.12,0-.24,0-.36C169.46,220.42,169.46,219.65,169.41,218.85Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.29,210.13c-.23-.45-.47-.89-.73-1.31l-.08-.12c-.2-.32-.41-.62-.63-.92l-.25-.35-.21-.25-.39-.47-.48-.54a15.66,15.66,0,0,0-1.18-1.13c-.4-.36-.82-.7-1.25-1s-.86-.62-1.3-.9a25.13,25.13,0,0,0-9-3.47l-.7-.11-.19,0-.79-.08a27.73,27.73,0,0,0-4.84,0c-.73.07-1.4.16-2,.27s-1.2.23-1.71.35l-.73.19-.65.19c-.4.13-.74.24-1,.35a7.88,7.88,0,0,0-.84.35s3.56,1.7,4.66,7.13a17.34,17.34,0,0,1,.27,3.58s1.74-5.5,4.84-4.93,3.75,4,7.92,4.33a9,9,0,0,0,3.21-.35c3-.85,5-2.74,8.12-.74Z",
    style: {
      fill: "#3E8804"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.29,210.13c-.23-.45-.47-.89-.73-1.31l-.08-.12c-.2-.32-.41-.62-.63-.92l-.25-.35-.21-.25-.39-.47-.48-.54a15.66,15.66,0,0,0-1.18-1.13c-.4-.36-.82-.7-1.25-1s-.86-.62-1.3-.9a25.13,25.13,0,0,0-9-3.47l-.7-.11-.19,0-.79-.08a27.73,27.73,0,0,0-4.84,0c-.73.07-1.4.16-2,.27s-1.2.23-1.71.35l-.73.19-.65.19c-.4.13-.74.24-1,.35a7.88,7.88,0,0,0-.84.35s3.56,1.7,4.66,7.13a17.34,17.34,0,0,1,.27,3.58s1.74-5.5,4.84-4.93,3.75,4,7.92,4.33a9,9,0,0,0,3.21-.35c3-.85,5-2.74,8.12-.74Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.29,201.15s9-1.05,18.07,6.38a12.35,12.35,0,0,1,2.83,3.38c3-.85,5-2.74,8.12-.74l0,0c-.23-.45-.47-.89-.73-1.31l-.08-.12c-.2-.32-.41-.62-.63-.92-.08-.12-.17-.23-.25-.34l-.21-.26-.39-.47-.48-.54a15.66,15.66,0,0,0-1.18-1.13c-.4-.36-.82-.7-1.25-1s-.86-.62-1.3-.9a25.13,25.13,0,0,0-9-3.47l-.7-.11-.19,0-.79-.08a27.73,27.73,0,0,0-4.84,0c-.73.07-1.4.16-2,.27s-1.2.23-1.71.35l-.73.19-.65.19c-.4.13-.74.24-1,.35a7.88,7.88,0,0,0-.84.35Z",
    style: {
      fill: "#3E8804",
      opacity: 0.30000000000000004
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--information-architect--inject-17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--information-architect--inject-17"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 349.18,
    cy: 378.63,
    r: 32.25,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.18,411.82a33.19,33.19,0,1,1,33.2-33.19A33.23,33.23,0,0,1,349.18,411.82Zm0-64.51a31.32,31.32,0,1,0,31.32,31.32A31.35,31.35,0,0,0,349.18,347.31Z",
    style: {
      fill: "#3E8804"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342.82,
    y: 356.44,
    width: 12.73,
    height: 5.73,
    style: {
      fill: "#3E8804"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342.82,
    y: 356.44,
    width: 12.73,
    height: 5.73,
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 359.54,
    y: 386.95,
    width: 12.73,
    height: 5.73,
    style: {
      fill: "#3E8804"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 359.54,
    y: 386.95,
    width: 12.73,
    height: 5.73,
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.94,362.56H342.43v-6.51h13.51Zm-12.73-.78h12v-4.95h-12Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.81,372.66H332.3v-6.51h13.51Zm-12.72-.78H345v-4.95H333.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366,372.66H352.49v-6.51H366Zm-12.72-.78h11.94v-4.95H353.28Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366,382.06H352.49v-6.51H366Zm-12.72-.79h11.94v-4.94H353.28Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.81,382.06H332.3v-6.51h13.51Zm-12.72-.79H345v-4.94H333.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.23,393.07H325.72v-6.52h13.51Zm-12.73-.79h11.94v-4.94H326.5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.94,393.07H342.43v-6.52h13.51Zm-12.73-.79h12v-4.94h-12Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.65,393.07H359.14v-6.52h13.51Zm-12.72-.79h11.94v-4.94H359.93Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.79,
    y: 362.17,
    width: 0.79,
    height: 2.08,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "359.64 366.54 358.86 366.54 358.86 364.64 339.45 364.64 339.45 366.54 338.67 366.54 338.67 363.85 359.64 363.85 359.64 366.54",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338.7,
    y: 381.66,
    width: 0.79,
    height: 2.08,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "349.55 387.03 348.76 387.03 348.76 384.13 333.09 384.13 333.09 387.03 332.3 387.03 332.3 383.34 349.55 383.34 349.55 387.03",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338.66,
    y: 372.27,
    width: 0.79,
    height: 3.67,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.86,
    y: 372.27,
    width: 0.79,
    height: 3.67,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "366.29 386.95 365.51 386.95 365.51 384.13 349.15 384.13 349.15 383.34 366.29 383.34 366.29 386.95",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.34,428v-7.85c0-.2.17-.3.53-.3h.27c.35,0,.52.1.52.3V428c0,.2-.17.3-.52.3h-.27C317.51,428.31,317.34,428.21,317.34,428Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.37,428v-7.85c0-.2.18-.3.53-.3h.29a1,1,0,0,1,.32.05.39.39,0,0,1,.19.21l2.61,4.95a8.7,8.7,0,0,1,.34.82l.05,0a4.22,4.22,0,0,1-.09-.84v-4.86c0-.2.17-.3.53-.3h.18c.35,0,.53.1.53.3V428c0,.2-.18.3-.53.3h-.24c-.27,0-.43-.08-.5-.23L321.89,423a4.45,4.45,0,0,1-.32-.76l-.06,0a3.43,3.43,0,0,1,.1.8v5c0,.2-.18.3-.53.3h-.18C320.55,428.31,320.37,428.21,320.37,428Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.51,428v-7.73a.45.45,0,0,1,.09-.3.34.34,0,0,1,.27-.09H331c.18,0,.27.14.27.43v.24c0,.29-.09.43-.27.43h-2.22v2.45h2c.18,0,.26.14.26.43v.24c0,.29-.08.43-.26.43h-2V428c0,.2-.17.3-.53.3H328C327.69,428.31,327.51,428.21,327.51,428Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.05,427.31a5.49,5.49,0,0,1-.77-3.24c0-2.84,1-4.27,3-4.27s3.05,1.43,3.05,4.27-1,4.3-3.05,4.3A2.62,2.62,0,0,1,333.05,427.31Zm3.55-.81a5.17,5.17,0,0,0,.43-2.43,5,5,0,0,0-.43-2.4,1.47,1.47,0,0,0-2.56,0,7.1,7.1,0,0,0,0,4.84,1.44,1.44,0,0,0,2.55,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.75,428v-7.73c0-.26.13-.39.37-.39H342a2.67,2.67,0,0,1,1.77.51,2.5,2.5,0,0,1-.52,3.71v.05a1,1,0,0,1,.44.48,5.42,5.42,0,0,1,.39.93l.74,2.34,0,.09s0,.06,0,.08-.19.23-.55.23H344a1,1,0,0,1-.35-.06.28.28,0,0,1-.17-.17l-.7-2.34a1.69,1.69,0,0,0-.42-.77,1,1,0,0,0-.68-.2h-.63V428q0,.3-.54.3h-.23Q339.75,428.31,339.75,428Zm2.36-4.39a.78.78,0,0,0,.65-.39,1.66,1.66,0,0,0,.27-1,1.45,1.45,0,0,0-.27-1A.87.87,0,0,0,342,421h-1v2.63Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.72,425.27l-1.26-2.43a5.19,5.19,0,0,1-.33-.76l-.05,0a6.19,6.19,0,0,1,.07.8V428c0,.2-.18.3-.53.3h-.22c-.35,0-.53-.1-.53-.3v-7.85c0-.2.18-.3.53-.3h.29c.27,0,.45.08.53.25l1.8,3.48a2.19,2.19,0,0,1,.19.58,3,3,0,0,1,.2-.58l1.8-3.48a.54.54,0,0,1,.53-.25H352c.35,0,.53.1.53.3V428c0,.2-.18.3-.53.3h-.22c-.35,0-.53-.1-.53-.3V422.9a6.19,6.19,0,0,1,.07-.8l-.05,0a5.19,5.19,0,0,1-.33.76l-1.26,2.43a.31.31,0,0,1-.32.21H349A.31.31,0,0,1,348.72,425.27Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.46,428.09a.88.88,0,0,1,0-.18l2.08-7.79c.05-.17.24-.26.55-.26h.5c.34,0,.52.09.55.26l2.08,7.79a.74.74,0,0,1,0,.18c0,.15-.16.22-.47.22h-.32c-.3,0-.47-.07-.5-.21l-.45-1.82h-2.37l-.44,1.82q0,.21-.48.21h-.31C353.62,428.31,353.46,428.24,353.46,428.09Zm3.84-2.89-.77-3.07c0-.13-.08-.39-.13-.78h-.06l0,.29a4.75,4.75,0,0,1-.1.49l-.75,3.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.16,428v-7h-1.62a.21.21,0,0,1-.19-.1.69.69,0,0,1-.06-.33v-.24a.66.66,0,0,1,.06-.33.2.2,0,0,1,.19-.1h4.54a.21.21,0,0,1,.2.1.66.66,0,0,1,.06.33v.24a.69.69,0,0,1-.06.33.23.23,0,0,1-.2.1h-1.61v7c0,.2-.18.3-.53.3h-.25C361.34,428.31,361.16,428.21,361.16,428Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.44,428v-7.85c0-.2.18-.3.53-.3h.28c.34,0,.52.1.52.3V428c0,.2-.18.3-.52.3H366C365.62,428.31,365.44,428.21,365.44,428Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369,427.31a5.57,5.57,0,0,1-.77-3.24c0-2.84,1-4.27,3-4.27s3.05,1.43,3.05,4.27-1,4.3-3.05,4.3A2.62,2.62,0,0,1,369,427.31Zm3.55-.81a5.17,5.17,0,0,0,.43-2.43,5,5,0,0,0-.43-2.4,1.47,1.47,0,0,0-2.56,0,7.1,7.1,0,0,0,0,4.84,1.44,1.44,0,0,0,2.55,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.67,428v-7.85c0-.2.17-.3.53-.3h.29a.91.91,0,0,1,.31.05.41.41,0,0,1,.2.21l2.61,4.95a6.85,6.85,0,0,1,.33.82l.06,0a4.26,4.26,0,0,1-.1-.84v-4.86c0-.2.18-.3.53-.3h.18c.35,0,.53.1.53.3V428c0,.2-.18.3-.53.3h-.24c-.26,0-.43-.08-.49-.23l-2.7-5.12a4.53,4.53,0,0,1-.31-.76l-.06,0a4,4,0,0,1,.09.8v5c0,.2-.17.3-.52.3h-.18C375.84,428.31,375.67,428.21,375.67,428Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.32,442.49a1.5,1.5,0,0,1,0-.18l2.07-7.79c.06-.17.24-.26.55-.26h.51c.33,0,.52.09.55.26l2.08,7.79a.74.74,0,0,1,0,.18c0,.15-.15.22-.47.22h-.32c-.3,0-.46-.07-.49-.21l-.46-1.82H326l-.45,1.82q0,.21-.48.21h-.31C324.48,442.71,324.32,442.64,324.32,442.49Zm3.84-2.89-.77-3.07c0-.13-.07-.39-.13-.78h-.06l-.05.29a2.88,2.88,0,0,1-.09.49l-.76,3.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.1,442.41v-7.73c0-.26.13-.4.37-.4h1.85a2.67,2.67,0,0,1,1.77.52,2.5,2.5,0,0,1-.52,3.71v.05a1.09,1.09,0,0,1,.44.48,5.42,5.42,0,0,1,.39.93l.74,2.34a.94.94,0,0,0,0,.09s0,.06,0,.08-.19.23-.55.23h-.27a1,1,0,0,1-.35-.06.33.33,0,0,1-.18-.17l-.69-2.34a1.75,1.75,0,0,0-.42-.77,1,1,0,0,0-.69-.2h-.62v3.24q0,.3-.54.3h-.23Q331.1,442.71,331.1,442.41Zm2.35-4.39a.79.79,0,0,0,.66-.39,1.68,1.68,0,0,0,.27-1,1.45,1.45,0,0,0-.27-1,.87.87,0,0,0-.72-.31h-1V438Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.73,441.73a5.58,5.58,0,0,1-.76-3.26,5.38,5.38,0,0,1,.78-3.21,2.77,2.77,0,0,1,2.39-1.06,3.26,3.26,0,0,1,.62.06,4.17,4.17,0,0,1,.54.14.36.36,0,0,1,.2.15.47.47,0,0,1,.05.25,1.66,1.66,0,0,1-.12.57c-.08.19-.18.25-.31.19a2.11,2.11,0,0,0-1-.22,1.53,1.53,0,0,0-1.4.76,6.49,6.49,0,0,0,0,4.75,1.51,1.51,0,0,0,1.4.78,2.27,2.27,0,0,0,1-.25l.11,0c.12,0,.22.08.28.24a1.31,1.31,0,0,1,.11.52.45.45,0,0,1-.32.42,3,3,0,0,1-.55.17,4,4,0,0,1-.71.07A2.76,2.76,0,0,1,337.73,441.73Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.79,442.41v-7.85c0-.2.18-.3.53-.3h.27q.51,0,.51.3v3.26h2.84v-3.26c0-.2.18-.3.53-.3h.25c.35,0,.53.1.53.3v7.85c0,.2-.18.3-.53.3h-.25c-.35,0-.53-.1-.53-.3v-3.47H344.1v3.47q0,.3-.51.3h-.27C343,442.71,342.79,442.61,342.79,442.41Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.05,442.41v-7.85c0-.2.18-.3.53-.3h.27c.35,0,.52.1.52.3v7.85c0,.2-.17.3-.52.3h-.27C350.23,442.71,350.05,442.61,350.05,442.41Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.36,442.41v-7h-1.62a.23.23,0,0,1-.2-.1.71.71,0,0,1-.05-.33v-.24a.69.69,0,0,1,.05-.33.22.22,0,0,1,.2-.11h4.53a.22.22,0,0,1,.21.11.66.66,0,0,1,.06.33V435a.69.69,0,0,1-.06.33.24.24,0,0,1-.21.1h-1.61v7c0,.2-.17.3-.52.3h-.26C354.53,442.71,354.36,442.61,354.36,442.41Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.68,442.59a.43.43,0,0,1-.09-.3v-7.61a.41.41,0,0,1,.09-.3.34.34,0,0,1,.27-.1h3.48c.18,0,.27.15.27.44V435c0,.28-.09.43-.27.43H359.9v2.45h2.27c.18,0,.26.14.26.43v.24c0,.29-.08.43-.26.43H359.9v2.64h2.53a.22.22,0,0,1,.21.1.69.69,0,0,1,.06.33v.24a.66.66,0,0,1-.06.33.22.22,0,0,1-.21.11H359A.34.34,0,0,1,358.68,442.59Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.53,441.73a5.57,5.57,0,0,1-.77-3.26,5.38,5.38,0,0,1,.78-3.21,2.77,2.77,0,0,1,2.39-1.06,3.36,3.36,0,0,1,.63.06,5.25,5.25,0,0,1,.54.14.33.33,0,0,1,.19.15.46.46,0,0,1,.06.25,1.68,1.68,0,0,1-.13.57c-.07.19-.18.25-.3.19a2.17,2.17,0,0,0-1-.22,1.52,1.52,0,0,0-1.4.76,6.49,6.49,0,0,0,0,4.75,1.5,1.5,0,0,0,1.4.78,2.3,2.3,0,0,0,1-.25l.11,0c.12,0,.21.08.28.24a1.3,1.3,0,0,1,.1.52.44.44,0,0,1-.31.42,3.64,3.64,0,0,1-.55.17,4.07,4.07,0,0,1-.71.07A2.75,2.75,0,0,1,364.53,441.73Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.8,442.41v-7h-1.62a.23.23,0,0,1-.2-.1.69.69,0,0,1-.06-.33v-.24a.66.66,0,0,1,.06-.33.22.22,0,0,1,.2-.11h4.53a.22.22,0,0,1,.21.11.66.66,0,0,1,.06.33V435a.69.69,0,0,1-.06.33.24.24,0,0,1-.21.1H372.1v7c0,.2-.17.3-.52.3h-.26C371,442.71,370.8,442.61,370.8,442.41Z",
    style: {
      fill: "#455a64"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--interaction-design--inject-17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--interaction-design--inject-17"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 414.97,
    cy: 289.5,
    r: 32.25,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415,322.69a33.19,33.19,0,1,1,33.19-33.19A33.23,33.23,0,0,1,415,322.69Zm0-64.5a31.32,31.32,0,1,0,31.31,31.31A31.34,31.34,0,0,0,415,258.19Z",
    style: {
      fill: "#3E8804"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.87,305.18l-.07,0H407.7a.51.51,0,0,0-.54.47v5.62a.17.17,0,0,0,0,.07v0a.52.52,0,0,0,.53.38h15.93a.49.49,0,0,0,.38-.13.42.42,0,0,0,.16-.32v-5.64A.45.45,0,0,0,423.87,305.18Z",
    style: {
      fill: "#3E8804"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.87,305.18l-.07,0H407.7a.51.51,0,0,0-.54.47v5.62a.17.17,0,0,0,0,.07v0a.52.52,0,0,0,.53.38h15.93a.49.49,0,0,0,.38-.13.42.42,0,0,0,.16-.32v-5.64A.45.45,0,0,0,423.87,305.18Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.7,312.19a1,1,0,0,1-1-.74s0,0,0-.06h0v-.08a.31.31,0,0,1,0-.09V305.6a1,1,0,0,1,1-1h16.15l.07,0,.14.05h0a1,1,0,0,1,.6.87v5.64a1,1,0,0,1-1,1Zm0-1h0l16,0,0-5.55h-16Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.47,302.69H407.73a.5.5,0,0,1-.5-.5v-2.4a21.22,21.22,0,0,1-2.83-3.13,55,55,0,0,1-3.06-4.64c-.7-1.13-1.42-2.31-2.18-3.44-.35-.52-.69-1-1-1.45-1.45-2.07-2.4-3.44-1.4-4.47a4.21,4.21,0,0,1,4-.47,14.58,14.58,0,0,1,5.11,3.79V267.07a3.18,3.18,0,0,1,6.36,0v8.22c1.13-.18,3.53-.29,4.88,1.5a4.39,4.39,0,0,1,5.35,2.18,4,4,0,0,1,4,2.57c1.17,2.68.78,6.85,0,9.86-.59,2.37-2.32,7.51-2.56,8.24v2.55A.5.5,0,0,1,423.47,302.69Zm-15.24-1H423v-2.13a.78.78,0,0,1,0-.16c0-.06,2-5.78,2.57-8.24.71-2.85,1.09-6.77,0-9.22a3,3,0,0,0-3.31-1.94.5.5,0,0,1-.55-.28,3.53,3.53,0,0,0-4.62-1.87.51.51,0,0,1-.62-.2c-1.28-2.13-4.59-1.28-4.63-1.27a.54.54,0,0,1-.43-.09.5.5,0,0,1-.19-.4v-8.82a2.18,2.18,0,0,0-4.36,0v20.2a.5.5,0,0,1-.88.33c-2.08-2.38-4-3.92-5.56-4.46a3.3,3.3,0,0,0-3,.22c-.43.44.38,1.6,1.5,3.19.31.45.66.94,1,1.48.77,1.14,1.5,2.32,2.2,3.47,1,1.68,2,3.26,3,4.56a18.88,18.88,0,0,0,2.85,3.11.49.49,0,0,1,.19.39Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.74,279.3a.5.5,0,0,1-.5-.5v-2.91a.5.5,0,0,1,.5-.5.51.51,0,0,1,.5.5v2.91A.51.51,0,0,1,411.74,279.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.92,280.59a.5.5,0,0,1-.5-.5v-2.7a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v2.7A.51.51,0,0,1,416.92,280.59Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.18,282.45a.5.5,0,0,1-.5-.5v-2.44a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5V282A.5.5,0,0,1,422.18,282.45Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.19,338.81V331c0-.2.18-.3.53-.3H385q.51,0,.51.3v7.84q0,.3-.51.3h-.28C384.37,339.11,384.19,339,384.19,338.81Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.23,338.81V331c0-.2.17-.3.53-.3H388a.74.74,0,0,1,.32.05.41.41,0,0,1,.2.21l2.6,4.94a5.85,5.85,0,0,1,.34.82l.06,0a4.35,4.35,0,0,1-.1-.84V331c0-.2.18-.3.53-.3h.18c.35,0,.53.1.53.3v7.84c0,.2-.18.3-.53.3h-.24c-.26,0-.43-.07-.49-.22l-2.7-5.13a4.06,4.06,0,0,1-.31-.75l-.06,0a4.08,4.08,0,0,1,.09.8v5c0,.2-.17.3-.52.3h-.18C387.4,339.11,387.23,339,387.23,338.81Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.58,338.81v-7H394a.2.2,0,0,1-.19-.1.69.69,0,0,1-.06-.33v-.24a.69.69,0,0,1,.06-.33.2.2,0,0,1,.19-.1h4.54a.21.21,0,0,1,.2.1.69.69,0,0,1,.06.33v.24a.69.69,0,0,1-.06.33.21.21,0,0,1-.2.1h-1.61v7c0,.2-.18.3-.53.3h-.25C395.76,339.11,395.58,339,395.58,338.81Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.9,339a.42.42,0,0,1-.08-.3v-7.6a.42.42,0,0,1,.08-.3.34.34,0,0,1,.28-.1h3.48c.17,0,.26.14.26.43v.24c0,.29-.09.43-.26.43h-2.54v2.45h2.27c.18,0,.27.15.27.43v.24c0,.29-.09.44-.27.44h-2.27V338h2.54a.21.21,0,0,1,.2.1.69.69,0,0,1,.06.33v.24a.69.69,0,0,1-.06.33.21.21,0,0,1-.2.1h-3.48A.34.34,0,0,1,399.9,339Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.27,338.81v-7.72c0-.27.13-.4.38-.4h1.84a2.62,2.62,0,0,1,1.77.52,2.49,2.49,0,0,1-.52,3.7v0a1.17,1.17,0,0,1,.45.48,5.66,5.66,0,0,1,.38.94l.75,2.34a.29.29,0,0,0,0,.09.22.22,0,0,1,0,.08c0,.15-.18.22-.55.22h-.27a.86.86,0,0,1-.34-.06.27.27,0,0,1-.18-.16l-.7-2.34a1.73,1.73,0,0,0-.41-.77,1,1,0,0,0-.69-.21h-.63v3.24q0,.3-.54.3h-.22C405.45,339.11,405.27,339,405.27,338.81Zm2.36-4.39a.78.78,0,0,0,.65-.39,1.65,1.65,0,0,0,.27-1,1.47,1.47,0,0,0-.26-1,.9.9,0,0,0-.72-.32h-1v2.63Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.71,338.9a1.05,1.05,0,0,1,0-.18l2.07-7.79c.06-.18.24-.26.55-.26h.51c.33,0,.52.08.55.26l2.08,7.79a.67.67,0,0,1,0,.18c0,.14-.15.21-.47.21h-.32c-.3,0-.46-.06-.49-.2l-.46-1.82h-2.36l-.45,1.82c0,.14-.19.2-.48.2h-.31Q410.71,339.11,410.71,338.9Zm3.84-2.89-.77-3.08c0-.12-.07-.38-.13-.78h-.06l0,.29a2.72,2.72,0,0,1-.09.49l-.76,3.08Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418,338.13a5.54,5.54,0,0,1-.77-3.25,5.44,5.44,0,0,1,.78-3.22,2.79,2.79,0,0,1,2.39-1.05,3.18,3.18,0,0,1,.62.06,3,3,0,0,1,.54.14.31.31,0,0,1,.2.14.5.5,0,0,1,.06.26,1.68,1.68,0,0,1-.13.57c-.08.18-.18.25-.3.18a2.31,2.31,0,0,0-1-.21,1.5,1.5,0,0,0-1.4.76,4.82,4.82,0,0,0-.45,2.37,4.89,4.89,0,0,0,.45,2.38,1.49,1.49,0,0,0,1.4.77,2.18,2.18,0,0,0,1-.25l.1,0c.12,0,.22.08.29.24a1.45,1.45,0,0,1,.1.51.42.42,0,0,1-.31.42,2.77,2.77,0,0,1-.55.17,3.29,3.29,0,0,1-.71.07A2.73,2.73,0,0,1,418,338.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.24,338.81v-7h-1.63a.21.21,0,0,1-.19-.1.69.69,0,0,1-.06-.33v-.24a.69.69,0,0,1,.06-.33.21.21,0,0,1,.19-.1h4.54a.22.22,0,0,1,.21.1.71.71,0,0,1,.05.33v.24a.71.71,0,0,1-.05.33.22.22,0,0,1-.21.1h-1.61v7c0,.2-.17.3-.52.3h-.26C424.41,339.11,424.24,339,424.24,338.81Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.52,338.81V331c0-.2.17-.3.53-.3h.27c.35,0,.52.1.52.3v7.84c0,.2-.17.3-.52.3h-.27C428.69,339.11,428.52,339,428.52,338.81Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.08,338.11a5.45,5.45,0,0,1-.78-3.23q0-4.28,3-4.27t3.05,4.27q0,4.29-3.05,4.29A2.61,2.61,0,0,1,432.08,338.11Zm3.55-.81a5.27,5.27,0,0,0,.42-2.42,5.17,5.17,0,0,0-.42-2.41,1.39,1.39,0,0,0-1.28-.75,1.37,1.37,0,0,0-1.28.75,5.14,5.14,0,0,0-.42,2.41,5.27,5.27,0,0,0,.42,2.42,1.45,1.45,0,0,0,2.56,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.74,338.81V331c0-.2.18-.3.53-.3h.29a.77.77,0,0,1,.32.05.39.39,0,0,1,.19.21l2.61,4.94a7.38,7.38,0,0,1,.34.82l.05,0a4.3,4.3,0,0,1-.09-.84V331c0-.2.17-.3.53-.3h.18c.35,0,.53.1.53.3v7.84c0,.2-.18.3-.53.3h-.24c-.27,0-.43-.07-.5-.22l-2.69-5.13a4,4,0,0,1-.32-.75l-.06,0a3.49,3.49,0,0,1,.1.8v5c0,.2-.18.3-.53.3h-.18C438.92,339.11,438.74,339,438.74,338.81Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.67,353.39a.42.42,0,0,1-.08-.3v-7.6a.42.42,0,0,1,.08-.3.33.33,0,0,1,.27-.1H401q3,0,3,4.2a5.25,5.25,0,0,1-.78,3.2,2.67,2.67,0,0,1-2.25,1h-2.09A.33.33,0,0,1,398.67,353.39Zm2.33-1a1.41,1.41,0,0,0,1.27-.74,4.67,4.67,0,0,0,.44-2.36c0-2.06-.57-3.1-1.71-3.1h-1.1v6.2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.59,353.39a.47.47,0,0,1-.08-.3v-7.6a.47.47,0,0,1,.08-.3.34.34,0,0,1,.28-.1h3.48c.17,0,.26.14.26.43v.24c0,.29-.09.43-.26.43h-2.53v2.45h2.27c.17,0,.26.15.26.43v.24c0,.29-.09.44-.26.44h-2.27v2.64h2.53a.21.21,0,0,1,.2.1.69.69,0,0,1,.06.33v.24a.69.69,0,0,1-.06.33.21.21,0,0,1-.2.1h-3.48A.34.34,0,0,1,405.59,353.39Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.49,353.41a2.56,2.56,0,0,1-.86-.42,1.1,1.1,0,0,1-.11-.14.45.45,0,0,1,0-.18,1.28,1.28,0,0,1,.11-.52c.07-.18.15-.27.25-.27a.51.51,0,0,1,.14,0l.12.07a2.29,2.29,0,0,0,1.42.44,1.28,1.28,0,0,0,.9-.31,1.28,1.28,0,0,0,.06-1.71,3.75,3.75,0,0,0-.9-.62,7.62,7.62,0,0,1-1-.63,2.3,2.3,0,0,1-.64-.74,2.34,2.34,0,0,1-.24-1.11,2.21,2.21,0,0,1,.69-1.72,2.58,2.58,0,0,1,1.79-.62,3.23,3.23,0,0,1,.82.1,2.48,2.48,0,0,1,.68.28.24.24,0,0,1,.12.22,1.47,1.47,0,0,1-.12.52c-.08.2-.16.3-.25.3a.85.85,0,0,1-.22-.08,2.52,2.52,0,0,0-1-.21,1.29,1.29,0,0,0-.87.29,1,1,0,0,0-.34.81,1.14,1.14,0,0,0,.16.63,1.5,1.5,0,0,0,.43.44c.17.12.43.27.77.46a5.74,5.74,0,0,1,1,.6,2.09,2.09,0,0,1,.82,1.81,2.33,2.33,0,0,1-.69,1.76,2.55,2.55,0,0,1-1.84.66A3.67,3.67,0,0,1,411.49,353.41Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.28,353.21v-7.84c0-.2.18-.3.53-.3h.28c.34,0,.52.1.52.3v7.84c0,.2-.18.3-.52.3h-.28C416.46,353.51,416.28,353.41,416.28,353.21Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.38,349.21v3.46c0,.3-.23.52-.69.68a4.92,4.92,0,0,1-1.53.22,2.7,2.7,0,0,1-2.32-1,5.41,5.41,0,0,1-.77-3.19,5.49,5.49,0,0,1,.79-3.27,2.78,2.78,0,0,1,2.39-1.06,3.71,3.71,0,0,1,.93.12,2.81,2.81,0,0,1,.77.3c.19.13.29.24.29.36a1,1,0,0,1-.19.49c-.12.21-.23.31-.33.31l-.25-.12a3.39,3.39,0,0,0-.5-.22,2.26,2.26,0,0,0-.67-.09,1.52,1.52,0,0,0-1.44.78,4.75,4.75,0,0,0-.45,2.33c0,2.12.59,3.18,1.78,3.18a3.28,3.28,0,0,0,.91-.12v-2.42h-.91c-.18,0-.27-.14-.27-.43v-.24c0-.29.09-.43.27-.43H424C424.26,348.81,424.38,348.94,424.38,349.21Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.94,353.21v-7.84c0-.2.18-.3.53-.3h.29a.77.77,0,0,1,.32.05.45.45,0,0,1,.2.21l2.6,4.94a7.38,7.38,0,0,1,.34.82l.06,0a3.69,3.69,0,0,1-.1-.84v-4.86c0-.2.18-.3.53-.3h.18c.35,0,.53.1.53.3v7.84c0,.2-.18.3-.53.3h-.24c-.27,0-.43-.07-.49-.22l-2.7-5.13a4,4,0,0,1-.32-.75l-.06,0a3.49,3.49,0,0,1,.1.8v5c0,.2-.18.3-.53.3h-.18C426.12,353.51,425.94,353.41,425.94,353.21Z",
    style: {
      fill: "#455a64"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--user-research--inject-17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--user-research--inject-17"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 429.11,
    cy: 184.57,
    r: 32.25,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.11,217.77a33.2,33.2,0,1,1,33.19-33.2A33.23,33.23,0,0,1,429.11,217.77Zm0-64.51a31.32,31.32,0,1,0,31.31,31.31A31.35,31.35,0,0,0,429.11,153.26Z",
    style: {
      fill: "#3E8804"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-icon--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M433.52,189.65a9.75,9.75,0,0,0-2.72-5.77,7.54,7.54,0,0,0-5.32-2.29H414.92c-4,0-7.47,3.44-8,8.06l-.45,3.66H434Z",
    style: {
      fill: "#3E8804"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.2,179.74a7.49,7.49,0,1,1,7.5-7.49A7.5,7.5,0,0,1,420.2,179.74Z",
    style: {
      fill: "#3E8804"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-icon--inject-17",
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M433.52,189.65a9.75,9.75,0,0,0-2.72-5.77,7.54,7.54,0,0,0-5.32-2.29H414.92c-4,0-7.47,3.44-8,8.06l-.45,3.66H434Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.2,179.74a7.49,7.49,0,1,1,7.5-7.49A7.5,7.5,0,0,1,420.2,179.74Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-icon--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M433.52,189.65a9.75,9.75,0,0,0-2.72-5.77,7.54,7.54,0,0,0-5.32-2.29H414.92c-4,0-7.47,3.44-8,8.06l-.45,3.66H434Z",
    style: {
      fill: "none",
      stroke: "#455a64",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.2,180.24a8,8,0,1,1,8-8A7.94,7.94,0,0,1,420.2,180.24Zm0-15a7,7,0,1,0,4.95,2.05A7,7,0,0,0,420.2,165.25Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M436.54,197.41a9.42,9.42,0,1,1,6.66-16.08h0a9.42,9.42,0,0,1-6.66,16.08Zm0-17.84a8.43,8.43,0,1,0,5.95,2.47h0A8.36,8.36,0,0,0,436.54,179.57Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.17,198.12a.54.54,0,0,1-.35-.14l-3.21-3.21a.5.5,0,0,1,.71-.71l3.21,3.21a.51.51,0,0,1,0,.71A.54.54,0,0,1,446.17,198.12Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.41,203.53a1.63,1.63,0,0,1-1.18-.49L445,198.8a1.67,1.67,0,0,1,2.37-2.36l4.23,4.23a1.68,1.68,0,0,1,0,2.37A1.63,1.63,0,0,1,450.41,203.53Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.17,233.62a2.3,2.3,0,0,1-.72-1.81v-5.74c0-.2.18-.3.53-.3h.25c.35,0,.53.1.53.3v5.73a1.31,1.31,0,0,0,.4,1,1.48,1.48,0,0,0,1,.38,1.44,1.44,0,0,0,1-.38,1.31,1.31,0,0,0,.4-1v-5.73c0-.2.17-.3.53-.3h.25c.35,0,.53.1.53.3v5.74a2.3,2.3,0,0,1-.72,1.81,3.48,3.48,0,0,1-4.05,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.05,234.11a2.5,2.5,0,0,1-.85-.42.6.6,0,0,1-.11-.14.34.34,0,0,1,0-.18,1.47,1.47,0,0,1,.11-.52c.07-.18.16-.27.25-.27a.43.43,0,0,1,.14,0l.13.07a2.34,2.34,0,0,0,1.41.44,1.32,1.32,0,0,0,.91-.31,1.3,1.3,0,0,0,.05-1.72,4.08,4.08,0,0,0-.9-.61,6.89,6.89,0,0,1-1-.63,2.09,2.09,0,0,1-.64-.74,2.52,2.52,0,0,1,.44-2.83,2.6,2.6,0,0,1,1.79-.62,3.18,3.18,0,0,1,.82.1,2.48,2.48,0,0,1,.68.28.24.24,0,0,1,.12.22,1.47,1.47,0,0,1-.12.52c-.08.19-.16.3-.25.3a.84.84,0,0,1-.21-.08,2.52,2.52,0,0,0-1-.21,1.31,1.31,0,0,0-.88.29,1,1,0,0,0-.34.81,1.14,1.14,0,0,0,.17.63,1.46,1.46,0,0,0,.42.44c.18.12.43.27.77.45a7.42,7.42,0,0,1,1,.6,2.24,2.24,0,0,1,.6.73,2.63,2.63,0,0,1-.46,2.85,2.56,2.56,0,0,1-1.84.66A3.69,3.69,0,0,1,401.05,234.11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.88,234.09a.47.47,0,0,1-.08-.3v-7.6a.52.52,0,0,1,.08-.31.38.38,0,0,1,.28-.09h3.48c.18,0,.26.14.26.43v.24c0,.29-.08.43-.26.43h-2.53v2.45h2.27c.17,0,.26.14.26.43V230c0,.29-.09.43-.26.43h-2.27v2.65h2.53a.2.2,0,0,1,.2.1.66.66,0,0,1,.06.33v.24a.69.69,0,0,1-.06.33.22.22,0,0,1-.2.1h-3.48A.34.34,0,0,1,405.88,234.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.26,233.91v-7.72c0-.27.12-.4.37-.4h1.85a2.59,2.59,0,0,1,1.76.52,2.5,2.5,0,0,1-.51,3.7v.05a1.15,1.15,0,0,1,.44.48,5.58,5.58,0,0,1,.39.94l.74,2.34a.29.29,0,0,1,0,.09.25.25,0,0,1,0,.07c0,.16-.19.23-.56.23h-.26a.91.91,0,0,1-.35-.06A.3.3,0,0,1,415,234l-.69-2.33a1.64,1.64,0,0,0-.42-.77,1,1,0,0,0-.69-.21h-.62v3.24q0,.3-.54.3h-.23Q411.26,234.21,411.26,233.91Zm2.35-4.39a.79.79,0,0,0,.66-.39,1.65,1.65,0,0,0,.27-1,1.41,1.41,0,0,0-.27-1,.88.88,0,0,0-.72-.32h-1v2.63Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.06,233.91v-7.72c0-.27.12-.4.37-.4h1.85a2.59,2.59,0,0,1,1.76.52,2.5,2.5,0,0,1-.51,3.7v.05a1.22,1.22,0,0,1,.44.48,5.58,5.58,0,0,1,.39.94l.74,2.34s0,.06,0,.09a.25.25,0,0,1,0,.07c0,.16-.19.23-.56.23h-.26a.91.91,0,0,1-.35-.06.3.3,0,0,1-.18-.17l-.69-2.33a1.64,1.64,0,0,0-.42-.77,1,1,0,0,0-.69-.21h-.62v3.24q0,.3-.54.3h-.23Q419.06,234.21,419.06,233.91Zm2.35-4.39a.79.79,0,0,0,.66-.39,1.65,1.65,0,0,0,.27-1,1.41,1.41,0,0,0-.27-1,.89.89,0,0,0-.72-.32h-1v2.63Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.32,234.09a.47.47,0,0,1-.08-.3v-7.6a.52.52,0,0,1,.08-.31.38.38,0,0,1,.28-.09h3.48c.18,0,.26.14.26.43v.24c0,.29-.08.43-.26.43h-2.53v2.45h2.27c.17,0,.26.14.26.43V230c0,.29-.09.43-.26.43h-2.27v2.65h2.53a.2.2,0,0,1,.2.1.66.66,0,0,1,.06.33v.24a.69.69,0,0,1-.06.33.22.22,0,0,1-.2.1H425.6A.34.34,0,0,1,425.32,234.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.22,234.11a2.65,2.65,0,0,1-.86-.42.94.94,0,0,1-.1-.14.34.34,0,0,1,0-.18,1.47,1.47,0,0,1,.11-.52c.07-.18.15-.27.25-.27a.51.51,0,0,1,.14,0l.12.07a2.35,2.35,0,0,0,1.42.44,1.28,1.28,0,0,0,.9-.31,1.11,1.11,0,0,0,.36-.89,1.14,1.14,0,0,0-.3-.83,4.08,4.08,0,0,0-.9-.61,7.62,7.62,0,0,1-1.05-.63,2.3,2.3,0,0,1-.64-.74,2.34,2.34,0,0,1-.24-1.11,2.21,2.21,0,0,1,.69-1.72,2.58,2.58,0,0,1,1.79-.62,3.23,3.23,0,0,1,.82.1,2.48,2.48,0,0,1,.68.28.24.24,0,0,1,.12.22,1.47,1.47,0,0,1-.12.52c-.08.19-.16.3-.25.3a1,1,0,0,1-.22-.08,2.52,2.52,0,0,0-1-.21,1.29,1.29,0,0,0-.87.29,1,1,0,0,0-.34.81,1.23,1.23,0,0,0,.16.63,1.5,1.5,0,0,0,.43.44c.18.12.43.27.77.45a7.42,7.42,0,0,1,1,.6,2.24,2.24,0,0,1,.6.73,2.61,2.61,0,0,1-.47,2.85,2.55,2.55,0,0,1-1.84.66A3.67,3.67,0,0,1,431.22,234.11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.05,234.09a.42.42,0,0,1-.08-.3v-7.6a.46.46,0,0,1,.08-.31.38.38,0,0,1,.28-.09h3.48c.17,0,.26.14.26.43v.24c0,.29-.09.43-.26.43h-2.54v2.45h2.27c.18,0,.27.14.27.43V230c0,.29-.09.43-.27.43h-2.27v2.65h2.54a.21.21,0,0,1,.2.1.66.66,0,0,1,.06.33v.24a.69.69,0,0,1-.06.33.23.23,0,0,1-.2.1h-3.48A.34.34,0,0,1,436.05,234.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.71,234a.77.77,0,0,1,0-.18l2.08-7.79c.05-.18.24-.26.55-.26h.5c.34,0,.52.08.55.26l2.08,7.79a.74.74,0,0,1,0,.18c0,.14-.16.21-.47.21h-.32c-.3,0-.47-.06-.5-.2l-.45-1.82h-2.37L442,234c0,.14-.19.2-.48.2h-.31Q440.71,234.21,440.71,234Zm3.84-2.9-.77-3.07a7.37,7.37,0,0,1-.13-.78h-.06l0,.29a4.27,4.27,0,0,1-.1.49l-.75,3.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.49,233.91v-7.72c0-.27.12-.4.37-.4h1.85a2.61,2.61,0,0,1,1.76.52A2.49,2.49,0,0,1,451,230v.05a1.17,1.17,0,0,1,.45.48,5.66,5.66,0,0,1,.38.94l.75,2.34a.29.29,0,0,0,0,.09.2.2,0,0,1,0,.07c0,.16-.18.23-.55.23h-.26a.88.88,0,0,1-.35-.06.26.26,0,0,1-.18-.17l-.7-2.33a1.73,1.73,0,0,0-.41-.77,1,1,0,0,0-.69-.21h-.63v3.24q0,.3-.54.3H448Q447.49,234.21,447.49,233.91Zm2.35-4.39a.78.78,0,0,0,.65-.39,1.65,1.65,0,0,0,.27-1,1.47,1.47,0,0,0-.26-1,.9.9,0,0,0-.72-.32h-1v2.63Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.12,233.23a5.54,5.54,0,0,1-.77-3.25,5.42,5.42,0,0,1,.78-3.22,2.79,2.79,0,0,1,2.39-1,3.36,3.36,0,0,1,.63.06,3.53,3.53,0,0,1,.54.14.32.32,0,0,1,.19.14.5.5,0,0,1,.06.26,1.68,1.68,0,0,1-.13.57c-.07.18-.18.24-.3.18a2.32,2.32,0,0,0-1-.22,1.51,1.51,0,0,0-1.4.77,4.8,4.8,0,0,0-.45,2.37,4.89,4.89,0,0,0,.45,2.38,1.49,1.49,0,0,0,1.4.77,2.18,2.18,0,0,0,1-.25l.11,0c.12,0,.21.08.28.24a1.25,1.25,0,0,1,.1.51.43.43,0,0,1-.31.42,2.77,2.77,0,0,1-.55.17,3.29,3.29,0,0,1-.71.07A2.75,2.75,0,0,1,454.12,233.23Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.17,233.91v-7.84c0-.2.18-.3.53-.3H460c.33,0,.5.1.5.3v3.26h2.85v-3.26c0-.2.17-.3.52-.3h.26c.35,0,.52.1.52.3v7.84c0,.2-.17.3-.52.3h-.26c-.35,0-.52-.1-.52-.3v-3.47h-2.85v3.47c0,.2-.17.3-.5.3h-.28C459.35,234.21,459.17,234.11,459.17,233.91Z",
    style: {
      fill: "#455a64"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Strategy--inject-17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--strategy--inject-17"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 388.63,
    cy: 88.08,
    r: 32.25,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.63,121.28a33.2,33.2,0,1,1,33.19-33.2A33.23,33.23,0,0,1,388.63,121.28Zm0-64.51a31.32,31.32,0,1,0,31.31,31.31A31.35,31.35,0,0,0,388.63,56.77Z",
    style: {
      fill: "#3E8804"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.1,76.65l.86-.76a6.78,6.78,0,0,0,.66-.84h-.07c-2.77-.61-5.23-.11-7.47-2.37a8.32,8.32,0,0,1-1.77-8.08,7.24,7.24,0,0,0-1.17,12.11h5.4C389.65,76.63,393.1,76.65,393.1,76.65Z",
    style: {
      fill: "#3E8804"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.54,76.7H384a2.64,2.64,0,0,0-2.65,2.65h6.24A4.1,4.1,0,0,1,389.54,76.7Z",
    style: {
      fill: "#3E8804"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.33,94.83c-2.56-3.09-3-7.78-3-11.61a16.34,16.34,0,0,1,.3-3.87h-3.72a41.89,41.89,0,0,1-3,15.9h9.81C390.58,95.11,390.45,95,390.33,94.83Z",
    style: {
      fill: "#3E8804"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.34,98.79a10.73,10.73,0,0,1-.33-3.21c-.11-.1-.2-.22-.3-.33H378v4.42h13.77A2.6,2.6,0,0,1,391.34,98.79Z",
    style: {
      fill: "#3E8804"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.91,104.88H375.05v4.42h21.54A12.1,12.1,0,0,0,395.91,104.88Z",
    style: {
      fill: "#3E8804"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.38,104c-1.11-1.45-2.55-2.35-3.39-3.95a4,4,0,0,1-.25-.37H380.13a12.15,12.15,0,0,0-3.24,5.22h19A4.61,4.61,0,0,0,395.38,104Z",
    style: {
      fill: "#3E8804"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M393.1,76.65l.86-.76s.46-.54.66-.84h-.07c-2.77-.61-5.23-.11-7.47-2.37a8.32,8.32,0,0,1-1.77-8.08,7.24,7.24,0,0,0-1.17,12.11h5.4C389.65,76.63,393.1,76.65,393.1,76.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.54,76.7H384a2.64,2.64,0,0,0-2.65,2.65h6.24A4.1,4.1,0,0,1,389.54,76.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.33,94.83c-2.56-3.09-3-7.78-3-11.61a16.34,16.34,0,0,1,.3-3.87h-3.72a41.89,41.89,0,0,1-3,15.9h9.81C390.58,95.11,390.45,95,390.33,94.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.34,98.79a10.73,10.73,0,0,1-.33-3.21c-.11-.1-.2-.22-.3-.33H378v4.42h13.77A2.6,2.6,0,0,1,391.34,98.79Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.91,104.88H375.05v4.42h21.54A12.1,12.1,0,0,0,395.91,104.88Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.38,104c-1.11-1.45-2.55-2.35-3.39-3.95a4,4,0,0,1-.25-.37H380.13a12.15,12.15,0,0,0-3.24,5.22h19A4.61,4.61,0,0,0,395.38,104Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M393.28,77.2H384l-.14-.11a7.74,7.74,0,1,1,9.59,0Zm-9-1h8.61a6.74,6.74,0,1,0-8.61,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.36,79.85H380.89v-.5A3.15,3.15,0,0,1,384,76.2h9.17a3.15,3.15,0,0,1,3.15,3.15Zm-14.41-1H395.3a2.14,2.14,0,0,0-2.09-1.65H384A2.14,2.14,0,0,0,382,78.85Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.09,95.75H380.16l.27-.68a41.17,41.17,0,0,0,3-15.72v-.5h10.43v.5a41.17,41.17,0,0,0,3,15.72Zm-15.47-1h14a42.42,42.42,0,0,1-2.79-14.9h-8.43A42.2,42.2,0,0,1,381.62,94.75Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.78,100.17H377.47V94.75h22.31Zm-21.31-1h20.31V95.75H378.47Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.71,109.8H374.55v-5.42h28.16Zm-27.16-1h26.16v-3.42H375.55Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401,105.39H376.21l.2-.65a12.73,12.73,0,0,1,3.38-5.44l.14-.13h17.39l.15.13a12.8,12.8,0,0,1,3.37,5.44Zm-23.45-1h22.07a11.74,11.74,0,0,0-2.74-4.22H380.33A11.74,11.74,0,0,0,377.59,104.39Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367,137.67a2.43,2.43,0,0,1-.85-.43.67.67,0,0,1-.11-.14.4.4,0,0,1,0-.17,1.25,1.25,0,0,1,.11-.52c.07-.18.15-.27.25-.27a.3.3,0,0,1,.14,0l.12.07a2.35,2.35,0,0,0,1.42.44,1.28,1.28,0,0,0,.9-.31,1.29,1.29,0,0,0,.06-1.72,3.76,3.76,0,0,0-.9-.61,7.62,7.62,0,0,1-1.05-.63,2.41,2.41,0,0,1-.64-.74,2.34,2.34,0,0,1-.24-1.11,2.21,2.21,0,0,1,.69-1.72,2.53,2.53,0,0,1,1.79-.62,3.23,3.23,0,0,1,.82.1,2.48,2.48,0,0,1,.68.28.24.24,0,0,1,.12.22,1.42,1.42,0,0,1-.12.51c-.08.2-.16.3-.25.3a.7.7,0,0,1-.22-.07,2.53,2.53,0,0,0-1-.22,1.24,1.24,0,0,0-.87.3,1,1,0,0,0-.34.81,1.14,1.14,0,0,0,.16.63,1.5,1.5,0,0,0,.43.44,7.64,7.64,0,0,0,.77.45,7.42,7.42,0,0,1,1,.6,2.4,2.4,0,0,1,.6.73,2.67,2.67,0,0,1-.47,2.85,2.55,2.55,0,0,1-1.84.66A3.79,3.79,0,0,1,367,137.67Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373,137.47v-7h-1.62a.2.2,0,0,1-.19-.1.69.69,0,0,1-.06-.33v-.24a.69.69,0,0,1,.06-.33.2.2,0,0,1,.19-.1h4.53a.22.22,0,0,1,.21.1.69.69,0,0,1,.06.33V130a.69.69,0,0,1-.06.33.22.22,0,0,1-.21.1h-1.6v7c0,.2-.18.3-.53.3h-.25C373.14,137.77,373,137.67,373,137.47Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.18,137.47v-7.73c0-.26.12-.39.37-.39h1.85a2.64,2.64,0,0,1,1.76.51,2.51,2.51,0,0,1-.51,3.71v.05a1.15,1.15,0,0,1,.44.48,5.42,5.42,0,0,1,.39.93l.74,2.34a.51.51,0,0,1,0,.09.31.31,0,0,1,0,.08c0,.15-.19.23-.56.23h-.26a.91.91,0,0,1-.35-.06.33.33,0,0,1-.18-.17l-.69-2.34a1.75,1.75,0,0,0-.42-.77,1,1,0,0,0-.69-.2h-.62v3.24q0,.3-.54.3h-.23Q377.18,137.77,377.18,137.47Zm2.35-4.39a.79.79,0,0,0,.66-.39,1.66,1.66,0,0,0,.27-1,1.45,1.45,0,0,0-.27-1,.87.87,0,0,0-.72-.31h-1v2.63Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.62,137.55a.88.88,0,0,1,0-.18l2.08-7.78c0-.18.24-.27.55-.27h.5c.34,0,.52.09.55.27l2.08,7.78a1,1,0,0,1,0,.18c0,.15-.16.22-.47.22h-.32c-.3,0-.47-.07-.5-.2l-.45-1.83h-2.37l-.44,1.83c0,.13-.19.2-.48.2h-.31C382.78,137.77,382.62,137.7,382.62,137.55Zm3.84-2.89-.77-3.07c0-.13-.08-.39-.13-.78h-.06l-.05.29a4.75,4.75,0,0,1-.1.49l-.75,3.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.32,137.47v-7H388.7a.2.2,0,0,1-.19-.1.69.69,0,0,1-.06-.33v-.24a.69.69,0,0,1,.06-.33.2.2,0,0,1,.19-.1h4.54a.21.21,0,0,1,.2.1.69.69,0,0,1,.06.33V130a.69.69,0,0,1-.06.33.21.21,0,0,1-.2.1h-1.61v7c0,.2-.18.3-.53.3h-.25C390.5,137.77,390.32,137.67,390.32,137.47Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.64,137.65a.42.42,0,0,1-.08-.3v-7.61a.45.45,0,0,1,.08-.3.38.38,0,0,1,.28-.09h3.48c.17,0,.26.14.26.43V130c0,.29-.09.43-.26.43h-2.54v2.45h2.27c.18,0,.27.14.27.43v.24c0,.29-.09.43-.27.43h-2.27v2.64h2.54a.23.23,0,0,1,.2.1.69.69,0,0,1,.06.33v.24a.64.64,0,0,1-.06.33.22.22,0,0,1-.2.11h-3.48A.38.38,0,0,1,394.64,137.65Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405,133.46v3.47c0,.3-.23.52-.69.67a4.91,4.91,0,0,1-1.53.23,2.72,2.72,0,0,1-2.32-1,7.08,7.08,0,0,1,0-6.46,2.79,2.79,0,0,1,2.39-1.07,3.71,3.71,0,0,1,.93.12,2.52,2.52,0,0,1,.77.31c.19.12.29.24.29.35a1,1,0,0,1-.19.5c-.12.2-.23.31-.33.31l-.25-.12a2.59,2.59,0,0,0-.5-.22,2.25,2.25,0,0,0-.67-.1,1.52,1.52,0,0,0-1.44.78,4.78,4.78,0,0,0-.45,2.33c0,2.12.59,3.18,1.78,3.18a3.28,3.28,0,0,0,.91-.12v-2.41h-.91c-.18,0-.27-.14-.27-.43v-.24c0-.29.09-.43.27-.43h1.83Q405,133.07,405,133.46Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408,137.47V134l-2-4.21a.72.72,0,0,1-.08-.24c0-.15.19-.22.56-.22h.33a1.61,1.61,0,0,1,.35,0,.34.34,0,0,1,.18.15l1.34,3.27,1.36-3.28a.21.21,0,0,1,.16-.14,1.19,1.19,0,0,1,.36,0h.27c.36,0,.54.08.54.22a.75.75,0,0,1-.07.24l-2,4.25v3.44c0,.2-.17.3-.52.3h-.26Q408,137.77,408,137.47Z",
    style: {
      fill: "#455a64"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Wireframes--inject-17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--wireframes--inject-17"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 251.22,
    cy: 64.4,
    r: 32.25,
    transform: "translate(147.42 302.06) rotate(-80.78)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.22,97.59A33.2,33.2,0,1,1,284.41,64.4,33.23,33.23,0,0,1,251.22,97.59Zm0-64.51A31.32,31.32,0,1,0,282.54,64.4,31.35,31.35,0,0,0,251.22,33.08Z",
    style: {
      fill: "#3E8804"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230.08,
    y: 48.32,
    width: 24.87,
    height: 17.17,
    style: {
      fill: "#3E8804"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230.08,
    y: 48.32,
    width: 24.87,
    height: 17.17,
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.32,65.86H229.71V48h25.61Zm-24.87-.74h24.12V48.69H230.45Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.14,
    y: 41.8,
    width: 0.74,
    height: 30.21,
    transform: "translate(57.91 224.15) rotate(-55.38)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.41,
    y: 56.53,
    width: 30.21,
    height: 0.74,
    transform: "matrix(0.82, -0.57, 0.57, 0.82, 10.53, 147.65)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.36,
    y: 49.52,
    width: 14.01,
    height: 0.74,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.36,
    y: 52.32,
    width: 14.01,
    height: 0.74,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.36,
    y: 55.13,
    width: 14.01,
    height: 0.74,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.36,
    y: 57.94,
    width: 14.01,
    height: 0.74,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.36,
    y: 60.74,
    width: 14.01,
    height: 0.74,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.36,
    y: 63.55,
    width: 14.01,
    height: 0.74,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.43,79.51H229.71v-10h42.72Zm-42-.74h41.24V70.3H230.45Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250.7,
    y: 53.05,
    width: 0.74,
    height: 42.98,
    transform: "translate(124.47 303.81) rotate(-77.63)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.58,
    y: 74.16,
    width: 42.98,
    height: 0.74,
    transform: "translate(-10.16 55.78) rotate(-12.43)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223,113.88,221.38,106l0-.15c0-.17.18-.26.55-.26h.2c.35,0,.53.08.57.24l.94,5.4c0,.17.08.5.14,1l.06.5.25-1.5,1-5.4a.21.21,0,0,1,.13-.17,1,1,0,0,1,.33-.05h.35a.87.87,0,0,1,.33.05.22.22,0,0,1,.14.17l1,5.42c.06.32.13.82.21,1.49,0-.05.06-.34.15-.89l.09-.6.93-5.4c0-.16.21-.24.56-.24h.17c.37,0,.55.09.55.26l0,.15-1.66,7.84c0,.13-.18.2-.47.2h-.57c-.28,0-.43-.07-.46-.2l-1-4.83-.18-1.44-.18,1.44-1,4.83c0,.13-.18.2-.46.2h-.57C223.2,114.08,223,114,223,113.88Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.11,113.78v-7.85c0-.2.18-.3.53-.3h.28q.51,0,.51.3v7.85q0,.3-.51.3h-.28C231.29,114.08,231.11,114,231.11,113.78Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.18,113.78v-7.73a.34.34,0,0,1,.38-.39h1.84a2.67,2.67,0,0,1,1.77.51,2.12,2.12,0,0,1,.6,1.68,2.09,2.09,0,0,1-1.12,2v.05a1.17,1.17,0,0,1,.45.48,6.21,6.21,0,0,1,.38.94l.74,2.34,0,.09a.17.17,0,0,1,0,.07c0,.16-.19.23-.55.23h-.27a.86.86,0,0,1-.34-.06.26.26,0,0,1-.18-.17l-.7-2.34a1.75,1.75,0,0,0-.41-.76,1,1,0,0,0-.69-.21h-.63v3.24q0,.3-.54.3h-.23Q234.18,114.08,234.18,113.78Zm2.36-4.39a.78.78,0,0,0,.65-.39,1.66,1.66,0,0,0,.27-1,1.45,1.45,0,0,0-.27-1,.89.89,0,0,0-.71-.31h-1v2.63Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.45,114a.41.41,0,0,1-.09-.3v-7.61a.45.45,0,0,1,.09-.3.35.35,0,0,1,.27-.09h3.48c.18,0,.27.14.27.43v.24c0,.29-.09.43-.27.43h-2.53v2.45h2.27c.18,0,.26.14.26.43v.24c0,.29-.08.43-.26.43h-2.27V113h2.53a.22.22,0,0,1,.21.11.64.64,0,0,1,.06.33v.24a.69.69,0,0,1-.06.33.24.24,0,0,1-.21.1h-3.48A.32.32,0,0,1,240.45,114Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.85,113.78v-7.73a.45.45,0,0,1,.08-.3.38.38,0,0,1,.28-.09h3.16c.18,0,.27.14.27.43v.24c0,.29-.09.43-.27.43h-2.22v2.45h2c.18,0,.27.14.27.43v.24c0,.29-.09.43-.27.43h-2v3.47c0,.2-.17.3-.52.3h-.26C246,114.08,245.85,114,245.85,113.78Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.9,113.78v-7.73c0-.26.12-.39.37-.39h1.85a2.64,2.64,0,0,1,1.76.51,2.51,2.51,0,0,1-.51,3.71v.05a1.22,1.22,0,0,1,.44.48,4.65,4.65,0,0,1,.38.94l.75,2.34s0,.06,0,.09a.19.19,0,0,1,0,.07c0,.16-.19.23-.56.23h-.26a.91.91,0,0,1-.35-.06.28.28,0,0,1-.18-.17l-.69-2.34a1.65,1.65,0,0,0-.42-.76,1,1,0,0,0-.69-.21h-.62v3.24q0,.3-.54.3h-.23Q250.9,114.08,250.9,113.78Zm2.35-4.39a.76.76,0,0,0,.65-.39,1.59,1.59,0,0,0,.28-1,1.45,1.45,0,0,0-.27-1,.91.91,0,0,0-.72-.31h-1v2.63Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.34,113.87a.77.77,0,0,1,0-.18l2.08-7.79c.05-.18.24-.27.55-.27h.5c.34,0,.52.09.55.27l2.08,7.79a.74.74,0,0,1,0,.18c0,.14-.16.21-.47.21h-.33c-.29,0-.46-.07-.49-.2l-.45-1.83h-2.37l-.44,1.83c0,.13-.19.2-.48.2h-.31Q256.34,114.08,256.34,113.87Zm3.84-2.9-.77-3.07c0-.13-.08-.39-.14-.78h0l-.05.29a4.27,4.27,0,0,1-.1.49l-.75,3.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.92,111.05l-1.26-2.44a6.72,6.72,0,0,1-.32-.76l0,0a5.91,5.91,0,0,1,.06.79v5.11c0,.2-.17.3-.53.3h-.21c-.36,0-.53-.1-.53-.3v-7.85c0-.2.17-.3.53-.3h.29a.51.51,0,0,1,.52.26l1.8,3.48a2,2,0,0,1,.19.57,3.11,3.11,0,0,1,.21-.57l1.8-3.48a.54.54,0,0,1,.53-.26h.29c.35,0,.52.1.52.3v7.85c0,.2-.17.3-.52.3H269c-.35,0-.53-.1-.53-.3v-5.11a5.91,5.91,0,0,1,.06-.79l-.05,0a6.72,6.72,0,0,1-.32.76l-1.26,2.44a.33.33,0,0,1-.32.2h-.35A.33.33,0,0,1,265.92,111.05Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.49,114a.42.42,0,0,1-.08-.3v-7.61a.45.45,0,0,1,.08-.3.38.38,0,0,1,.28-.09h3.48c.17,0,.26.14.26.43v.24c0,.29-.09.43-.26.43h-2.54v2.45H275c.18,0,.27.14.27.43v.24c0,.29-.09.43-.27.43h-2.27V113h2.54a.22.22,0,0,1,.2.11.64.64,0,0,1,.06.33v.24a.69.69,0,0,1-.06.33.23.23,0,0,1-.2.1h-3.48A.34.34,0,0,1,271.49,114Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.38,114a2.43,2.43,0,0,1-.85-.43.63.63,0,0,1-.11-.13.48.48,0,0,1,0-.18,1.41,1.41,0,0,1,.1-.52c.08-.18.16-.27.26-.27a.24.24,0,0,1,.13,0l.13.07a2.35,2.35,0,0,0,1.42.44,1.3,1.3,0,0,0,.9-.31,1.11,1.11,0,0,0,.36-.89,1.13,1.13,0,0,0-.3-.83,3.76,3.76,0,0,0-.9-.61,7.06,7.06,0,0,1-1.05-.63,2.19,2.19,0,0,1-.64-.74,2.33,2.33,0,0,1-.25-1.11,2.21,2.21,0,0,1,.69-1.72,2.61,2.61,0,0,1,1.8-.62,3.1,3.1,0,0,1,.81.1,2.43,2.43,0,0,1,.69.28.24.24,0,0,1,.12.22,1.42,1.42,0,0,1-.12.51c-.08.2-.17.3-.25.3a.63.63,0,0,1-.22-.07,2.52,2.52,0,0,0-1-.21,1.28,1.28,0,0,0-.88.29,1,1,0,0,0-.33.81,1.14,1.14,0,0,0,.16.63,1.5,1.5,0,0,0,.43.44,8.53,8.53,0,0,0,.76.45,6.25,6.25,0,0,1,1,.6,2.17,2.17,0,0,1,.83,1.82,2.33,2.33,0,0,1-.69,1.76,2.55,2.55,0,0,1-1.84.66A3.74,3.74,0,0,1,277.38,114Z",
    style: {
      fill: "#455a64"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Colors--inject-17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--colors--inject-17"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 110.97,
    cy: 88.08,
    r: 32.25,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111,121.28a33.2,33.2,0,1,1,33.19-33.2A33.23,33.23,0,0,1,111,121.28Zm0-64.51a31.32,31.32,0,1,0,31.31,31.31A31.35,31.35,0,0,0,111,56.77Z",
    style: {
      fill: "#3E8804"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.27,111.15A13.91,13.91,0,0,1,94.61,108c-5.52-4.43-8.54-10.27-9.25-17.84a24.83,24.83,0,0,1,7.88-20.31c3.83-3.47,10.57-7.19,20.91-5.19,13.33,2.58,16.62,14.23,16.07,19.15-.38,3.44-1.29,7-5.31,9.75a16.39,16.39,0,0,1-5.74,2.21l-1,.26c-1.78.46-3,.78-3.93,2a6.71,6.71,0,0,0-1.13,3.67,15.52,15.52,0,0,1-.23,1.73c-.83,4.08-3.1,6.6-6.77,7.47A11.66,11.66,0,0,1,103.27,111.15Zm5.26-46.09a21.25,21.25,0,0,0-14.62,5.49A23.79,23.79,0,0,0,86.36,90h0c.69,7.39,3.51,12.85,8.88,17.16a12.34,12.34,0,0,0,10.6,2.67c3.26-.78,5.29-3,6-6.69.11-.55.16-1.11.22-1.64a7.63,7.63,0,0,1,1.32-4.17c1.09-1.46,2.65-1.86,4.45-2.32l1.07-.27a15.32,15.32,0,0,0,5.41-2.07c3.49-2.39,4.48-5.33,4.89-9C129.74,79,126.61,68.05,114,65.6A28.18,28.18,0,0,0,108.53,65.06Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.55,106.54a5,5,0,0,1-4.44-7.27h0a5,5,0,0,1,9.21.74,5,5,0,0,1-4.77,6.53ZM100,99.73h0a4,4,0,1,0,7.11,3.63A4,4,0,0,0,105.38,98,4,4,0,0,0,100,99.73Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.12,75.39a3.11,3.11,0,1,1,1.35,4.18A3.11,3.11,0,0,1,94.12,75.39Z",
    style: {
      fill: "#3E8804"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.12,75.39a3.11,3.11,0,1,1,1.35,4.18A3.11,3.11,0,0,1,94.12,75.39Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.88,80.41a3.61,3.61,0,0,1-3.21-5.25,3.62,3.62,0,0,1,4.86-1.57,3.61,3.61,0,0,1-1.65,6.82Zm0-6.22a2.44,2.44,0,0,0-.8.13,2.53,2.53,0,0,0-1.52,1.29,2.61,2.61,0,1,0,3.51-1.13A2.64,2.64,0,0,0,96.89,74.19Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.06,85.31a3.11,3.11,0,1,1,1.35,4.19A3.1,3.1,0,0,1,90.06,85.31Z",
    style: {
      fill: "#3E8804"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.06,85.31a3.11,3.11,0,1,1,1.35,4.19A3.1,3.1,0,0,1,90.06,85.31Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.83,90.34a3.64,3.64,0,0,1-3.44-2.5,3.67,3.67,0,0,1,.22-2.76,3.6,3.6,0,0,1,2.11-1.79,3.56,3.56,0,0,1,2.75.22A3.62,3.62,0,0,1,96,88.37a3.63,3.63,0,0,1-3.21,2Zm0-6.23a2.85,2.85,0,0,0-.81.13,2.64,2.64,0,0,0-1.52,1.3A2.61,2.61,0,1,0,94,84.4,2.64,2.64,0,0,0,92.83,84.11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.9,70.23a3.11,3.11,0,1,1,1.36,4.18A3.12,3.12,0,0,1,103.9,70.23Z",
    style: {
      fill: "#3E8804"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.9,70.23a3.11,3.11,0,1,1,1.36,4.18A3.12,3.12,0,0,1,103.9,70.23Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.67,75.25a3.66,3.66,0,0,1-1.64-.39,3.6,3.6,0,0,1-1.79-2.11,3.56,3.56,0,0,1,.22-2.75h0a3.62,3.62,0,1,1,3.21,5.25Zm-2.32-4.79A2.6,2.6,0,0,0,105.49,74,2.6,2.6,0,0,0,109,72.83a2.61,2.61,0,1,0-4.65-2.37Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.74,72.11a3.11,3.11,0,1,1,1.36,4.19A3.12,3.12,0,0,1,114.74,72.11Z",
    style: {
      fill: "#3E8804"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.74,72.11a3.11,3.11,0,1,1,1.36,4.19A3.12,3.12,0,0,1,114.74,72.11Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.51,77.14a3.55,3.55,0,0,1-1.64-.4,3.6,3.6,0,0,1-1.57-4.85h0a3.6,3.6,0,0,1,2.1-1.8A3.62,3.62,0,0,1,121,72.42a3.61,3.61,0,0,1-3.44,4.72Zm-2.32-4.8a2.61,2.61,0,0,0,4.65,2.38,2.67,2.67,0,0,0,.16-2,2.64,2.64,0,0,0-1.3-1.52,2.63,2.63,0,0,0-3.51,1.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.55,81.4a3.11,3.11,0,1,1,1.35,4.19A3.1,3.1,0,0,1,120.55,81.4Z",
    style: {
      fill: "#3E8804"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.55,81.4a3.11,3.11,0,1,1,1.35,4.19A3.1,3.1,0,0,1,120.55,81.4Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.31,86.43a3.61,3.61,0,0,1-1.1-7.05,3.61,3.61,0,1,1,1.1,7.05Zm0-6.22a2.54,2.54,0,0,0-.81.13A2.59,2.59,0,0,0,121,81.63a2.61,2.61,0,1,0,3.51-1.14A2.56,2.56,0,0,0,123.32,80.21Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.29,99.7a7.94,7.94,0,0,0-4.78,7.34c0,3.16,2.6,5.4,4.11,5.48,0,0-1.25-1.34.91-3s4.36-4.67,3.27-8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127,98.7a16.86,16.86,0,0,0,4-5.31c1.26-2.58,7.58-17.61,5.59-18.59s-10,13.23-11.27,15.8a16.9,16.9,0,0,0-1.73,6.45Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127,99.19l-3.84-1.88V97A16.91,16.91,0,0,1,125,90.42c.08-.18,9.1-17.32,11.82-16s-5.31,19-5.4,19.14A16.73,16.73,0,0,1,127.22,99Zm-3-2.39,2.86,1.4a16.56,16.56,0,0,0,3.73-5c2.31-4.71,7.07-17.39,5.78-18s-8.4,10.9-10.71,15.61A16.72,16.72,0,0,0,124,96.8Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.15,
    y: 97.33,
    width: 2.95,
    height: 3.74,
    transform: "translate(-19.3 167.45) rotate(-63.89)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.86,102l-4.16-2,1.69-3.46,4.16,2Zm-3-2.45,2.56,1.25.91-1.85-2.56-1.25Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.62,112.52s-1.25-1.34.91-3c.26-.21.53-.44.79-.68a3.92,3.92,0,0,1-2-1.56c-.71-1.14-.81-2.57-1.47-3.73a4.16,4.16,0,0,0-.86-1,7.94,7.94,0,0,0-1.44,4.59C117.54,110.2,120.11,112.44,121.62,112.52Z",
    style: {
      fill: "#3E8804"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.62,112.52s-1.25-1.34.91-3c.26-.21.53-.44.79-.68a3.92,3.92,0,0,1-2-1.56c-.71-1.14-.81-2.57-1.47-3.73a4.16,4.16,0,0,0-.86-1,7.94,7.94,0,0,0-1.44,4.59C117.54,110.2,120.11,112.44,121.62,112.52Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.62,113h0c-1.81-.09-4.51-2.62-4.53-5.92a8.39,8.39,0,0,1,5.05-7.75.48.48,0,0,1,.37,0L126,101a.43.43,0,0,1,.22.27c1.39,4.31-2.26,7.61-3.41,8.53a2.55,2.55,0,0,0-1.1,1.59,1.18,1.18,0,0,0,.24.81.44.44,0,0,1,.07.49A.46.46,0,0,1,121.62,113Zm.67-12.76A7.5,7.5,0,0,0,118,107a5.57,5.57,0,0,0,2.88,4.81,2.5,2.5,0,0,1,0-.48,3.28,3.28,0,0,1,1.43-2.24c1-.81,4.23-3.7,3.18-7.38Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.46,136.79a5.55,5.55,0,0,1-.77-3.26,5.38,5.38,0,0,1,.78-3.21,2.77,2.77,0,0,1,2.39-1.06,3.36,3.36,0,0,1,.63.06,3.49,3.49,0,0,1,.54.15.32.32,0,0,1,.19.14.46.46,0,0,1,.06.25,1.68,1.68,0,0,1-.13.57c-.07.19-.18.25-.3.19a2.17,2.17,0,0,0-1-.22,1.52,1.52,0,0,0-1.4.76,4.82,4.82,0,0,0-.45,2.37,4.91,4.91,0,0,0,.45,2.39,1.51,1.51,0,0,0,1.4.77,2.18,2.18,0,0,0,1-.25l.11,0c.12,0,.21.08.28.24a1.3,1.3,0,0,1,.1.52.44.44,0,0,1-.31.42,3.64,3.64,0,0,1-.55.17,3.29,3.29,0,0,1-.71.07A2.75,2.75,0,0,1,94.46,136.79Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.69,136.77a5.49,5.49,0,0,1-.78-3.24c0-2.84,1-4.27,3-4.27s3,1.43,3,4.27-1,4.3-3,4.3A2.61,2.61,0,0,1,99.69,136.77Zm3.55-.81a5.27,5.27,0,0,0,.43-2.43,5.13,5.13,0,0,0-.43-2.4,1.47,1.47,0,0,0-2.56,0,5.17,5.17,0,0,0-.42,2.41,5.29,5.29,0,0,0,.42,2.43,1.45,1.45,0,0,0,2.56,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.5,137.65a.41.41,0,0,1-.09-.3v-7.73c0-.2.18-.3.53-.3h.25c.36,0,.53.1.53.3v7H110a.24.24,0,0,1,.21.1.58.58,0,0,1,.07.33v.24a.54.54,0,0,1-.07.33.22.22,0,0,1-.21.11h-3.24A.35.35,0,0,1,106.5,137.65Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.53,136.77a5.57,5.57,0,0,1-.77-3.24c0-2.84,1-4.27,3-4.27s3,1.43,3,4.27-1,4.3-3,4.3A2.62,2.62,0,0,1,111.53,136.77Zm3.55-.81a5.14,5.14,0,0,0,.43-2.43,5,5,0,0,0-.43-2.4,1.37,1.37,0,0,0-1.27-.75,1.39,1.39,0,0,0-1.29.74,7.1,7.1,0,0,0,0,4.84,1.44,1.44,0,0,0,2.55,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.24,137.47v-7.73c0-.26.12-.39.37-.39h1.84a2.67,2.67,0,0,1,1.77.51,2.12,2.12,0,0,1,.6,1.68,2.09,2.09,0,0,1-1.12,2v.05a1.17,1.17,0,0,1,.45.48,6.49,6.49,0,0,1,.38.93l.74,2.34,0,.09a.25.25,0,0,1,0,.08c0,.15-.18.23-.55.23h-.27a.86.86,0,0,1-.34-.06.28.28,0,0,1-.18-.17l-.7-2.34a1.86,1.86,0,0,0-.41-.77,1.07,1.07,0,0,0-.69-.2h-.63v3.24q0,.3-.54.3h-.23C118.41,137.77,118.24,137.67,118.24,137.47Zm2.35-4.39a.78.78,0,0,0,.65-.39,1.66,1.66,0,0,0,.27-1,1.51,1.51,0,0,0-.26-1,.9.9,0,0,0-.72-.31h-1v2.63Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.91,137.67a2.35,2.35,0,0,1-.85-.43.45.45,0,0,1-.11-.14.29.29,0,0,1,0-.17,1.43,1.43,0,0,1,.11-.52c.07-.18.16-.27.25-.27a.27.27,0,0,1,.14,0l.13.07a2.34,2.34,0,0,0,1.41.44,1.32,1.32,0,0,0,.91-.31,1.15,1.15,0,0,0,.35-.89,1.13,1.13,0,0,0-.3-.83,3.76,3.76,0,0,0-.9-.61,6.89,6.89,0,0,1-1-.63,2.17,2.17,0,0,1-.64-.74,2.52,2.52,0,0,1,.44-2.83,2.55,2.55,0,0,1,1.79-.62,3.18,3.18,0,0,1,.82.1,2.48,2.48,0,0,1,.68.28.24.24,0,0,1,.12.22,1.42,1.42,0,0,1-.12.51c-.08.2-.16.3-.25.3a.67.67,0,0,1-.21-.07,2.56,2.56,0,0,0-1-.22,1.27,1.27,0,0,0-.88.3,1,1,0,0,0-.34.81,1.23,1.23,0,0,0,.16.63,1.5,1.5,0,0,0,.43.44c.18.12.43.27.77.45a7.42,7.42,0,0,1,1,.6,2.14,2.14,0,0,1,.6.73,2.63,2.63,0,0,1-.46,2.85,2.56,2.56,0,0,1-1.84.66A3.69,3.69,0,0,1,124.91,137.67Z",
    style: {
      fill: "#455a64"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Typography--inject-17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--typography--inject-17"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 70.48,
    cy: 184.57,
    r: 32.25,
    transform: "translate(-123 224.58) rotate(-80.78)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.48,217.77a33.2,33.2,0,1,1,33.2-33.2A33.23,33.23,0,0,1,70.48,217.77Zm0-64.51a31.32,31.32,0,1,0,31.32,31.31A31.35,31.35,0,0,0,70.48,153.26Z",
    style: {
      fill: "#3E8804"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.45,188.85l-2.32,6.7H48.27l9.08-26.3h6.17L73,195.55h-5.2l-2.42-6.7Zm8.81-4.09c-2.09-6-3.35-9.6-4-11.85h0c-.64,2.47-2,6.71-3.71,11.85Z",
    style: {
      fill: "#3E8804"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.45,188.85l-2.32,6.7H48.27l9.08-26.3h6.17L73,195.55h-5.2l-2.42-6.7Zm8.81-4.09c-2.09-6-3.35-9.6-4-11.85h0c-.64,2.47-2,6.71-3.71,11.85Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92,190.77a40.19,40.19,0,0,0,.26,4.78H87.74a8.88,8.88,0,0,1-.28-2.13c-.7,1.17-2.11,2.59-5.68,2.59-4.68,0-6.66-3.07-6.66-6.08,0-4.42,3.52-6.46,9.28-6.46h3v-1.35c0-1.51-.52-3.12-3.42-3.12-2.61,0-3.13,1.19-3.42,2.64H76c.28-3.21,2.27-6.12,8.1-6.1,5.09,0,7.87,2,7.87,6.63Zm-4.61-4.33H84.86c-3.48,0-5,1-5,3.2A2.82,2.82,0,0,0,83,192.55c3.86,0,4.36-2.65,4.36-5.56Z",
    style: {
      fill: "#3E8804"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92,190.77a40.19,40.19,0,0,0,.26,4.78H87.74a8.88,8.88,0,0,1-.28-2.13c-.7,1.17-2.11,2.59-5.68,2.59-4.68,0-6.66-3.07-6.66-6.08,0-4.42,3.52-6.46,9.28-6.46h3v-1.35c0-1.51-.52-3.12-3.42-3.12-2.61,0-3.13,1.19-3.42,2.64H76c.28-3.21,2.27-6.12,8.1-6.1,5.09,0,7.87,2,7.87,6.63Zm-4.61-4.33H84.86c-3.48,0-5,1-5,3.2A2.82,2.82,0,0,0,83,192.55c3.86,0,4.36-2.65,4.36-5.56Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7,196.05H67.44L65,189.35H55.81l-2.32,6.7H47.57L57,168.75h6.88Zm-5.56-1h4.14l-9.11-25.3H57.71L49,195.05h3.81l2.32-6.7H65.72ZM65,185.26h-9.1l.5-1.54c1.57-4.81,2.81-8.62,3.42-10.93l.1-.38h.76l.14.37c.58,2.11,1.73,5.43,3.63,10.92Zm-7.72-1h6.31l-.08-.24c-1.49-4.28-2.52-7.25-3.18-9.36-.68,2.32-1.72,5.53-3,9.37Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.78,196.51c-5,0-7.16-3.31-7.16-6.58,0-4.49,3.47-7,9.78-7h2.48v-.85c0-1.3-.35-2.62-2.92-2.62-2.31,0-2.67.93-2.93,2.24l-.07.4H75.48l0-.54c.22-2.45,1.61-6.56,8.53-6.56h.08c5.54,0,8.36,2.43,8.36,7.13v8.6a40.93,40.93,0,0,0,.25,4.67l.14.61H87.4l-.12-.32a5.7,5.7,0,0,1-.22-1A7.13,7.13,0,0,1,81.78,196.51ZM84.4,184c-4,0-8.78,1-8.78,6,0,2.57,1.61,5.58,6.16,5.58,2.58,0,4.3-.77,5.25-2.34l.87-1.46.06,1.7a9.51,9.51,0,0,0,.17,1.64h3.56c-.1-1-.19-2.9-.19-4.28v-8.6c0-4.15-2.34-6.1-7.37-6.13h-.08c-4.43,0-6.94,1.72-7.46,5.1h3.55c.33-1.34,1-2.64,3.82-2.64,2.6,0,3.92,1.22,3.92,3.62V184ZM83,193.05a3.31,3.31,0,0,1-3.65-3.41c0-3.32,3.13-3.7,5.48-3.7h3V187C87.89,190,87.31,193.05,83,193.05Zm1.83-6.11c-4,0-4.48,1.36-4.48,2.7A2.33,2.33,0,0,0,83,192.05c3.21,0,3.86-1.93,3.86-5.06v-.05Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.62,233.91v-7H40a.21.21,0,0,1-.19-.1.69.69,0,0,1-.06-.33v-.24a.69.69,0,0,1,.06-.33.21.21,0,0,1,.19-.1h4.54a.2.2,0,0,1,.2.1.69.69,0,0,1,.06.33v.24a.69.69,0,0,1-.06.33.2.2,0,0,1-.2.1H42.93v7c0,.2-.17.3-.53.3h-.25C41.8,234.21,41.62,234.11,41.62,233.91Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.24,233.91v-3.48l-2-4.21a.54.54,0,0,1-.08-.24c0-.14.18-.21.56-.21h.33a1.09,1.09,0,0,1,.34,0,.25.25,0,0,1,.18.15l1.35,3.26,1.35-3.28a.25.25,0,0,1,.17-.14,1.73,1.73,0,0,1,.36,0h.26c.36,0,.54.08.54.21a.56.56,0,0,1-.07.24l-2,4.25v3.44c0,.2-.18.3-.53.3h-.25Q47.24,234.21,47.24,233.91Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.62,233.91v-7.72a.46.46,0,0,1,.09-.31.38.38,0,0,1,.28-.09h2a2.51,2.51,0,0,1,1.56.52,2.29,2.29,0,0,1,.68,1.92,2.68,2.68,0,0,1-.39,1.56,2,2,0,0,1-.88.75,2.41,2.41,0,0,1-.88.19H52.92v3.18c0,.2-.18.3-.53.3h-.24C51.8,234.21,51.62,234.11,51.62,233.91ZM54,229.64a.84.84,0,0,0,.64-.31,1.59,1.59,0,0,0,.29-1.1,1.47,1.47,0,0,0-.29-1,1,1,0,0,0-.7-.3h-1v2.75Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.91,233.21a5.55,5.55,0,0,1-.77-3.23q0-4.28,3-4.27t3,4.27q0,4.29-3,4.29A2.63,2.63,0,0,1,57.91,233.21Zm3.56-.81a5.27,5.27,0,0,0,.42-2.42,5.17,5.17,0,0,0-.42-2.41,1.48,1.48,0,0,0-2.57,0,5.16,5.16,0,0,0-.41,2.41,5.27,5.27,0,0,0,.42,2.42,1.45,1.45,0,0,0,2.56,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.64,229.9v3.47c0,.3-.23.52-.69.67a4.64,4.64,0,0,1-1.53.23,2.72,2.72,0,0,1-2.32-1,5.41,5.41,0,0,1-.77-3.19,5.47,5.47,0,0,1,.79-3.27,2.78,2.78,0,0,1,2.39-1.06,3.71,3.71,0,0,1,.93.12,2.52,2.52,0,0,1,.77.3c.19.12.29.24.29.35a1,1,0,0,1-.19.5c-.12.21-.23.31-.33.31l-.25-.12a3.39,3.39,0,0,0-.5-.22,2.26,2.26,0,0,0-.67-.09,1.52,1.52,0,0,0-1.44.78,4.74,4.74,0,0,0-.45,2.32c0,2.13.59,3.19,1.78,3.19a3.28,3.28,0,0,0,.91-.13v-2.41h-.91c-.18,0-.27-.14-.27-.43v-.24c0-.29.09-.43.27-.43h1.83Q69.64,229.51,69.64,229.9Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.24,233.91v-7.72c0-.27.12-.4.37-.4h1.85a2.59,2.59,0,0,1,1.76.52,2.5,2.5,0,0,1-.51,3.7v.05a1.15,1.15,0,0,1,.44.48,5.58,5.58,0,0,1,.39.94l.74,2.34a.29.29,0,0,1,0,.09.25.25,0,0,1,0,.07c0,.16-.19.23-.56.23H75.5a.91.91,0,0,1-.35-.06A.3.3,0,0,1,75,234l-.69-2.33a1.64,1.64,0,0,0-.42-.77,1,1,0,0,0-.69-.21h-.62v3.24q0,.3-.54.3h-.23Q71.24,234.21,71.24,233.91Zm2.35-4.39a.79.79,0,0,0,.66-.39,1.65,1.65,0,0,0,.27-1,1.41,1.41,0,0,0-.27-1,.88.88,0,0,0-.72-.32h-1v2.63Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.68,234a.77.77,0,0,1,0-.18L78.78,226c0-.18.24-.26.55-.26h.5c.34,0,.52.08.55.26l2.08,7.79a.74.74,0,0,1,0,.18c0,.14-.16.21-.47.21H81.7c-.29,0-.46-.06-.49-.2l-.45-1.82H78.39L78,234c0,.14-.19.2-.48.2h-.31Q76.68,234.21,76.68,234Zm3.84-2.9L79.75,228a7.37,7.37,0,0,1-.13-.78h-.06l0,.29a4.27,4.27,0,0,1-.1.49l-.75,3.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.43,233.91v-7.72a.46.46,0,0,1,.09-.31.39.39,0,0,1,.28-.09h2a2.51,2.51,0,0,1,1.56.52,2.29,2.29,0,0,1,.68,1.92,2.68,2.68,0,0,1-.39,1.56,2,2,0,0,1-.88.75,2.41,2.41,0,0,1-.88.19H84.73v3.18c0,.2-.18.3-.53.3H84C83.61,234.21,83.43,234.11,83.43,233.91Zm2.38-4.27a.87.87,0,0,0,.65-.31,1.65,1.65,0,0,0,.28-1.1,1.42,1.42,0,0,0-.29-1,1,1,0,0,0-.7-.3h-1v2.75Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.26,233.91v-7.84c0-.2.18-.3.53-.3h.28c.33,0,.5.1.5.3v3.26h2.85v-3.26c0-.2.17-.3.52-.3h.26c.35,0,.52.1.52.3v7.84c0,.2-.17.3-.52.3h-.26c-.35,0-.52-.1-.52-.3v-3.47H90.57v3.47c0,.2-.17.3-.5.3h-.28C89.44,234.21,89.26,234.11,89.26,233.91Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.86,233.91v-3.48l-2-4.21a.6.6,0,0,1-.09-.24q0-.21.57-.21h.32a1.16,1.16,0,0,1,.35,0,.25.25,0,0,1,.18.15l1.34,3.26,1.36-3.28c0-.07.08-.11.17-.14a1.6,1.6,0,0,1,.36,0h.26c.36,0,.54.08.54.21a.56.56,0,0,1-.07.24l-2,4.25v3.44c0,.2-.18.3-.53.3H98.4Q97.86,234.21,97.86,233.91Z",
    style: {
      fill: "#455a64"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--graphic-design--inject-17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--graphic-design--inject-17"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 84.62,
    cy: 289.5,
    r: 32.25,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.62,322.69a33.19,33.19,0,1,1,33.2-33.19A33.23,33.23,0,0,1,84.62,322.69Zm0-64.5a31.32,31.32,0,1,0,31.32,31.31A31.34,31.34,0,0,0,84.62,258.19Z",
    style: {
      fill: "#3E8804"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.44,306.19l-.08,0H78.27a.51.51,0,0,0-.54.46v5.63a.17.17,0,0,0,0,.07v0a.53.53,0,0,0,.52.38H91.2a.51.51,0,0,0,.37-.13.42.42,0,0,0,.16-.33V306.6A.45.45,0,0,0,91.44,306.19Z",
    style: {
      fill: "#3E8804"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.44,306.19l-.08,0H78.27a.51.51,0,0,0-.54.46v5.63a.17.17,0,0,0,0,.07v0a.53.53,0,0,0,.52.38H91.2a.51.51,0,0,0,.37-.13.42.42,0,0,0,.16-.33V306.6A.45.45,0,0,0,91.44,306.19Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.27,313.2a1,1,0,0,1-1-.74.07.07,0,0,0,0,0h0v0a.2.2,0,0,1,0-.07V306.6a.93.93,0,0,1,.27-.66,1.1,1.1,0,0,1,.76-.3H91.4l.09,0h0l.14.05a1,1,0,0,1,.59.87v5.63a.89.89,0,0,1-.34.71,1.1,1.1,0,0,1-.7.25Zm0-1h0l13,0,0-5.54h-13Zm13.06-6.06h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.82,303.78H80.65a1.09,1.09,0,0,1-1.08-.92,21.89,21.89,0,0,0-4.14-10.18,1.47,1.47,0,0,1-.27-1.41L84,273.56a.48.48,0,0,1,.56-.26.31.31,0,0,1,.18.09.37.37,0,0,1,.19-.09.48.48,0,0,1,.56.26l8.75,17.54a1.37,1.37,0,0,1,0,1.37A21.82,21.82,0,0,0,89.9,302.9,1.08,1.08,0,0,1,88.82,303.78Zm-4.89-27.87-7.87,15.8a.94.94,0,0,0,.17.37,22.87,22.87,0,0,1,4.33,10.65.11.11,0,0,0,.09,0h8.17a.16.16,0,0,0,.1,0,22.75,22.75,0,0,1,4.48-10.88.77.77,0,0,0-.07-.32l-7.79-15.63v15.48a2.23,2.23,0,1,1-1.61,0Zm.81,16.26a.6.6,0,0,1-.22.09,1.23,1.23,0,1,0,.43,0A.5.5,0,0,1,84.74,292.17Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101,283.29a.5.5,0,0,1-.49-.4,16.06,16.06,0,0,0-31.52,0,.52.52,0,0,1-.59.4.5.5,0,0,1-.39-.59,17.06,17.06,0,0,1,33.49,0,.51.51,0,0,1-.4.59Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101,269.92H68.48a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5H101a.5.5,0,0,1,.5.5A.5.5,0,0,1,101,269.92Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.75,269.42a1.77,1.77,0,1,1-1.77-1.77A1.76,1.76,0,0,1,102.75,269.42Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70,269.42a1.77,1.77,0,1,1-1.77-1.77A1.76,1.76,0,0,1,70,269.42Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.75,283.34a1.77,1.77,0,1,1-1.77-1.77A1.77,1.77,0,0,1,102.75,283.34Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70,283.34a1.77,1.77,0,1,1-1.77-1.77A1.77,1.77,0,0,1,70,283.34Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.43,334.81v3.46c0,.3-.24.52-.69.68a5,5,0,0,1-1.53.22,2.7,2.7,0,0,1-2.33-1,5.41,5.41,0,0,1-.77-3.19,5.49,5.49,0,0,1,.79-3.27,2.79,2.79,0,0,1,2.39-1.06,3.85,3.85,0,0,1,.94.12,2.86,2.86,0,0,1,.76.3c.19.13.29.24.29.36a1.05,1.05,0,0,1-.18.49c-.13.21-.24.31-.33.31a1.06,1.06,0,0,1-.26-.12,3.39,3.39,0,0,0-.5-.22,2.26,2.26,0,0,0-.67-.09,1.52,1.52,0,0,0-1.44.78,4.75,4.75,0,0,0-.45,2.33c0,2.12.6,3.18,1.78,3.18a3.28,3.28,0,0,0,.91-.12v-2.42h-.91c-.18,0-.26-.14-.26-.43v-.24c0-.29.08-.43.26-.43h1.84C69.31,334.41,69.43,334.54,69.43,334.81Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71,338.81v-7.72c0-.27.13-.4.37-.4h1.85a2.62,2.62,0,0,1,1.77.52,2.13,2.13,0,0,1,.6,1.68,2.1,2.1,0,0,1-1.12,2v0a1.09,1.09,0,0,1,.44.48,5.58,5.58,0,0,1,.39.94l.74,2.34,0,.09s0,.05,0,.08-.19.22-.55.22h-.27a1,1,0,0,1-.35-.06.32.32,0,0,1-.18-.16l-.69-2.34a1.64,1.64,0,0,0-.42-.77,1,1,0,0,0-.69-.21h-.62v3.24q0,.3-.54.3h-.23Q71,339.11,71,338.81Zm2.35-4.39A.79.79,0,0,0,74,334a1.65,1.65,0,0,0,.27-1,1.41,1.41,0,0,0-.27-1,.88.88,0,0,0-.72-.32h-1v2.63Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.46,338.9s0-.09,0-.18l2.08-7.79c0-.18.24-.26.55-.26h.5c.34,0,.52.08.56.26l2.07,7.79a.45.45,0,0,1,0,.18c0,.14-.16.21-.47.21h-.32c-.3,0-.47-.06-.5-.2l-.45-1.82H78.17l-.44,1.82c0,.14-.19.2-.48.2h-.31Q76.46,339.11,76.46,338.9ZM80.3,336l-.77-3.08a7.37,7.37,0,0,1-.13-.78h-.06l0,.29a4.27,4.27,0,0,1-.1.49L78.44,336Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.21,338.81v-7.72a.41.41,0,0,1,.09-.3.37.37,0,0,1,.29-.1h2a2.51,2.51,0,0,1,1.56.52,2.26,2.26,0,0,1,.68,1.92,2.68,2.68,0,0,1-.39,1.56,2,2,0,0,1-.88.75,2.41,2.41,0,0,1-.87.19H84.51v3.18c0,.2-.18.3-.53.3h-.24C83.39,339.11,83.21,339,83.21,338.81Zm2.38-4.27a.86.86,0,0,0,.65-.31,1.65,1.65,0,0,0,.28-1.1,1.42,1.42,0,0,0-.29-1,1,1,0,0,0-.7-.3h-1v2.75Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.05,338.81V331c0-.2.17-.3.52-.3h.28c.34,0,.5.1.5.3v3.26H93.2V331c0-.2.17-.3.53-.3H94c.35,0,.53.1.53.3v7.84c0,.2-.18.3-.53.3h-.25c-.36,0-.53-.1-.53-.3v-3.46H90.35v3.46c0,.2-.16.3-.5.3h-.28C89.22,339.11,89.05,339,89.05,338.81Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.31,338.81V331c0-.2.17-.3.52-.3h.28c.34,0,.52.1.52.3v7.84c0,.2-.18.3-.52.3h-.28C96.48,339.11,96.31,339,96.31,338.81Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.85,338.13a5.55,5.55,0,0,1-.76-3.25,5.44,5.44,0,0,1,.78-3.22,2.77,2.77,0,0,1,2.39-1.05,3.34,3.34,0,0,1,.62.06,3,3,0,0,1,.54.14.34.34,0,0,1,.2.14.63.63,0,0,1,0,.26,1.94,1.94,0,0,1-.12.57c-.08.18-.18.25-.31.18a2.24,2.24,0,0,0-1-.21,1.51,1.51,0,0,0-1.4.76,4.82,4.82,0,0,0-.45,2.37,4.89,4.89,0,0,0,.45,2.38,1.5,1.5,0,0,0,1.4.77,2.15,2.15,0,0,0,1-.25l.11,0c.12,0,.21.08.28.24a1.25,1.25,0,0,1,.1.51.42.42,0,0,1-.31.42,2.57,2.57,0,0,1-.55.17,3.23,3.23,0,0,1-.71.07A2.74,2.74,0,0,1,99.85,338.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.32,353.39a.42.42,0,0,1-.08-.3v-7.6a.42.42,0,0,1,.08-.3.34.34,0,0,1,.28-.1h2.08q3,0,3,4.2a5.25,5.25,0,0,1-.78,3.2,2.67,2.67,0,0,1-2.25,1H68.6A.34.34,0,0,1,68.32,353.39Zm2.33-1a1.41,1.41,0,0,0,1.27-.74,4.67,4.67,0,0,0,.44-2.36c0-2.06-.57-3.1-1.71-3.1H69.56v6.2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.24,353.39a.47.47,0,0,1-.08-.3v-7.6a.47.47,0,0,1,.08-.3.34.34,0,0,1,.28-.1H79c.18,0,.26.14.26.43v.24c0,.29-.08.43-.26.43H76.47v2.45h2.27c.17,0,.26.15.26.43v.24c0,.29-.09.44-.26.44H76.47v2.64H79a.2.2,0,0,1,.2.1.69.69,0,0,1,.06.33v.24a.69.69,0,0,1-.06.33.2.2,0,0,1-.2.1H75.52A.34.34,0,0,1,75.24,353.39Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.14,353.41a2.65,2.65,0,0,1-.86-.42.94.94,0,0,1-.1-.14.32.32,0,0,1,0-.18,1.47,1.47,0,0,1,.11-.52c.07-.18.15-.27.25-.27a.43.43,0,0,1,.14,0l.12.07a2.31,2.31,0,0,0,1.42.44,1.32,1.32,0,0,0,.91-.31,1.14,1.14,0,0,0,.35-.89,1.1,1.1,0,0,0-.3-.82,3.75,3.75,0,0,0-.9-.62,6.89,6.89,0,0,1-1-.63,2.22,2.22,0,0,1-.65-.74,2.34,2.34,0,0,1-.24-1.11,2.21,2.21,0,0,1,.69-1.72,2.6,2.6,0,0,1,1.79-.62,3.23,3.23,0,0,1,.82.1,2.48,2.48,0,0,1,.68.28.24.24,0,0,1,.12.22,1.47,1.47,0,0,1-.12.52c-.08.2-.16.3-.25.3a1,1,0,0,1-.22-.08,2.52,2.52,0,0,0-1-.21,1.29,1.29,0,0,0-.87.29,1,1,0,0,0-.34.81,1.23,1.23,0,0,0,.16.63,1.5,1.5,0,0,0,.43.44c.18.12.43.27.77.46a5.74,5.74,0,0,1,1,.6,2.11,2.11,0,0,1,.6.72,2.38,2.38,0,0,1,.23,1.09,2.33,2.33,0,0,1-.69,1.76,2.57,2.57,0,0,1-1.85.66A3.67,3.67,0,0,1,81.14,353.41Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.94,353.21v-7.84c0-.2.17-.3.52-.3h.28c.34,0,.52.1.52.3v7.84c0,.2-.18.3-.52.3h-.28C86.11,353.51,85.94,353.41,85.94,353.21Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94,349.21v3.46c0,.3-.23.52-.69.68a4.92,4.92,0,0,1-1.53.22,2.7,2.7,0,0,1-2.33-1,5.41,5.41,0,0,1-.77-3.19,5.49,5.49,0,0,1,.79-3.27A2.79,2.79,0,0,1,91.9,345a3.85,3.85,0,0,1,.94.12,2.86,2.86,0,0,1,.76.3c.19.13.29.24.29.36a1.05,1.05,0,0,1-.18.49c-.13.21-.24.31-.33.31a1.06,1.06,0,0,1-.26-.12,3.39,3.39,0,0,0-.5-.22,2.26,2.26,0,0,0-.67-.09,1.52,1.52,0,0,0-1.44.78,4.75,4.75,0,0,0-.45,2.33c0,2.12.6,3.18,1.78,3.18a3.28,3.28,0,0,0,.91-.12v-2.42h-.91c-.18,0-.26-.14-.26-.43v-.24c0-.29.08-.43.26-.43h1.84C93.92,348.81,94,348.94,94,349.21Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.6,353.21v-7.84c0-.2.17-.3.52-.3h.29a.74.74,0,0,1,.32.05.45.45,0,0,1,.2.21l2.6,4.94a5.85,5.85,0,0,1,.34.82l.06,0a3.69,3.69,0,0,1-.1-.84v-4.86c0-.2.18-.3.53-.3h.18c.35,0,.53.1.53.3v7.84c0,.2-.18.3-.53.3h-.24c-.26,0-.43-.07-.49-.22l-2.7-5.13a3.47,3.47,0,0,1-.31-.75l-.06,0a4.08,4.08,0,0,1,.09.8v5c0,.2-.17.3-.53.3h-.18C95.77,353.51,95.6,353.41,95.6,353.21Z",
    style: {
      fill: "#455a64"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--visual-design--inject-17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--visual-design--inject-17"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 150.41,
    cy: 378.63,
    r: 32.25,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.41,411.82a33.19,33.19,0,1,1,33.19-33.19A33.23,33.23,0,0,1,150.41,411.82Zm0-64.51a31.32,31.32,0,1,0,31.31,31.32A31.36,31.36,0,0,0,150.41,347.31Z",
    style: {
      fill: "#3E8804"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.41,393.07c-14.58,0-24.1-12-24.19-12.08-.33-.29-.33-.54,0-.83.1-.12,9.62-12.28,24.2-12.28s24.1,12.16,24.19,12.28c.33.29.32.54,0,.83C174.51,381.11,165,393.07,150.41,393.07Zm-22.88-12.5c1.79,2.06,10.42,11.19,22.88,11.19s21.09-9.13,22.88-11.19c-1.79-2.09-10.42-11.38-22.88-11.38S129.31,378.48,127.53,380.57Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.46,372a34.38,34.38,0,0,0-4.8-4,32.87,32.87,0,0,0-5.37-3.08,27.44,27.44,0,0,0-23.76,0,32.16,32.16,0,0,0-5.37,3.08,33.63,33.63,0,0,0-4.8,4,30.21,30.21,0,0,1,9.76-7.89,26.06,26.06,0,0,1,24.58,0A30.34,30.34,0,0,1,172.46,372Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150.41,
    cy: 380.47,
    r: 9.21,
    transform: "translate(-241.17 498.99) rotate(-85.27)",
    style: {
      fill: "#3E8804"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150.41,
    cy: 380.47,
    r: 9.21,
    transform: "translate(-241.17 498.99) rotate(-85.27)",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.41,390.18a9.71,9.71,0,1,1,9.7-9.71A9.73,9.73,0,0,1,150.41,390.18Zm0-18.41a8.71,8.71,0,1,0,8.7,8.7A8.71,8.71,0,0,0,150.41,371.77Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.86,380.47a4.45,4.45,0,1,1-4.45-4.44A4.45,4.45,0,0,1,154.86,380.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.49,377.41a2,2,0,1,1-2-2A2,2,0,0,1,156.49,377.41Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.6,428.1l-2-7.84a.29.29,0,0,0,0-.09.28.28,0,0,1,0-.09c0-.15.18-.22.54-.22h.25c.3,0,.46.08.5.24l1.44,6.11.1.68h0l.1-.69,1.47-6.1q.06-.24.51-.24h.23c.36,0,.54.07.54.22a1,1,0,0,1,0,.19l-2,7.83c0,.14-.2.21-.5.21h-.63C135.8,428.31,135.63,428.24,135.6,428.1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.38,428v-7.85c0-.2.17-.3.52-.3h.28c.34,0,.52.1.52.3V428c0,.2-.18.3-.52.3h-.28C140.55,428.31,140.38,428.21,140.38,428Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144,428.21a2.43,2.43,0,0,1-.85-.43.67.67,0,0,1-.11-.14.4.4,0,0,1,0-.17,1.41,1.41,0,0,1,.1-.52c.08-.18.16-.27.26-.27a.3.3,0,0,1,.14,0l.12.06a2.29,2.29,0,0,0,1.42.45,1.3,1.3,0,0,0,.9-.31,1.29,1.29,0,0,0,.06-1.72,3.76,3.76,0,0,0-.9-.61,10.32,10.32,0,0,1-1-.63,2.29,2.29,0,0,1-.64-.74,2.38,2.38,0,0,1-.24-1.12,2.19,2.19,0,0,1,.68-1.71,2.56,2.56,0,0,1,1.8-.62,3.23,3.23,0,0,1,.82.1,2.48,2.48,0,0,1,.68.28.24.24,0,0,1,.12.21,1.42,1.42,0,0,1-.12.52c-.08.2-.17.3-.25.3a.63.63,0,0,1-.22-.07,2.53,2.53,0,0,0-1-.22,1.24,1.24,0,0,0-.87.3,1,1,0,0,0-.34.81,1.18,1.18,0,0,0,.16.63,1.63,1.63,0,0,0,.43.44,8.53,8.53,0,0,0,.76.45,7,7,0,0,1,1,.6,2.19,2.19,0,0,1,.82,1.81,2.33,2.33,0,0,1-.69,1.77,2.55,2.55,0,0,1-1.84.66A3.74,3.74,0,0,1,144,428.21Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.33,427.72a2.3,2.3,0,0,1-.72-1.81v-5.75c0-.2.17-.3.53-.3h.25c.35,0,.53.1.53.3v5.74a1.29,1.29,0,0,0,.4,1,1.57,1.57,0,0,0,2.07,0,1.32,1.32,0,0,0,.39-1v-5.74c0-.2.18-.3.53-.3h.25c.35,0,.53.1.53.3v5.75a2.3,2.3,0,0,1-.72,1.81,3.46,3.46,0,0,1-4,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155,428.09s0-.08,0-.18l2.08-7.79c.05-.17.24-.26.55-.26h.5c.34,0,.52.09.56.26l2.07,7.79a.74.74,0,0,1,0,.18c0,.15-.16.22-.47.22H160c-.3,0-.47-.07-.5-.21l-.45-1.82h-2.37l-.44,1.82q0,.21-.48.21h-.31C155.13,428.31,155,428.24,155,428.09Zm3.84-2.89-.77-3.07c0-.13-.08-.39-.13-.78h-.06l0,.29a4.75,4.75,0,0,1-.1.49L157,425.2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.86,428.19a.45.45,0,0,1-.09-.3v-7.73c0-.2.18-.3.53-.3h.25c.35,0,.53.1.53.3v7h2.29a.24.24,0,0,1,.21.1.68.68,0,0,1,.07.33v.24a.65.65,0,0,1-.07.33.22.22,0,0,1-.21.1h-3.24A.34.34,0,0,1,161.86,428.19Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.11,442.59a.43.43,0,0,1-.09-.3v-7.61a.41.41,0,0,1,.09-.3.34.34,0,0,1,.27-.1h2.09c2,0,3,1.41,3,4.2a5.21,5.21,0,0,1-.78,3.2,2.66,2.66,0,0,1-2.24,1h-2.09A.34.34,0,0,1,134.11,442.59Zm2.32-1a1.41,1.41,0,0,0,1.28-.73,4.85,4.85,0,0,0,.44-2.37c0-2.06-.57-3.09-1.72-3.09h-1.09v6.19Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141,442.59a.43.43,0,0,1-.08-.3v-7.61a.42.42,0,0,1,.08-.3.38.38,0,0,1,.28-.1h3.48c.17,0,.26.15.26.44V435c0,.28-.09.43-.26.43h-2.54v2.45h2.27c.18,0,.27.14.27.43v.24c0,.29-.09.43-.27.43h-2.27v2.64h2.54a.21.21,0,0,1,.2.1.69.69,0,0,1,.06.33v.24a.66.66,0,0,1-.06.33.22.22,0,0,1-.2.11h-3.48A.38.38,0,0,1,141,442.59Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.92,442.61a2.52,2.52,0,0,1-.85-.43A.67.67,0,0,1,146,442a.4.4,0,0,1,0-.17,1.41,1.41,0,0,1,.1-.52c.08-.18.16-.27.25-.27a.27.27,0,0,1,.14,0l.13.07a2.35,2.35,0,0,0,1.42.44,1.35,1.35,0,0,0,.9-.31,1.12,1.12,0,0,0,.36-.89,1.17,1.17,0,0,0-.3-.83A3.65,3.65,0,0,0,148,439a6.89,6.89,0,0,1-1-.63,2.21,2.21,0,0,1-.89-1.86,2.19,2.19,0,0,1,.69-1.71,2.57,2.57,0,0,1,1.8-.63,3.1,3.1,0,0,1,.81.11,2.17,2.17,0,0,1,.69.28.24.24,0,0,1,.12.22,1.42,1.42,0,0,1-.12.51c-.08.2-.17.3-.26.3a.67.67,0,0,1-.21-.07,2.37,2.37,0,0,0-1-.22,1.29,1.29,0,0,0-.88.3,1,1,0,0,0-.33.81,1.16,1.16,0,0,0,.16.63,1.36,1.36,0,0,0,.43.43,8.18,8.18,0,0,0,.76.46,7.42,7.42,0,0,1,1,.6,2.05,2.05,0,0,1,.6.73,2.63,2.63,0,0,1-.46,2.85,2.55,2.55,0,0,1-1.84.66A3.74,3.74,0,0,1,146.92,442.61Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.72,442.41v-7.85c0-.2.18-.3.53-.3h.27c.35,0,.52.1.52.3v7.85c0,.2-.17.3-.52.3h-.27C151.9,442.71,151.72,442.61,151.72,442.41Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.82,438.4v3.47c0,.29-.23.52-.69.67a4.91,4.91,0,0,1-1.53.23,2.71,2.71,0,0,1-2.32-1,5.35,5.35,0,0,1-.78-3.2,5.45,5.45,0,0,1,.8-3.26,2.77,2.77,0,0,1,2.39-1.07,3.71,3.71,0,0,1,.93.12,2.45,2.45,0,0,1,.76.31c.2.12.3.24.3.35a1.12,1.12,0,0,1-.19.5q-.18.3-.33.3a1.09,1.09,0,0,1-.25-.12,2.7,2.7,0,0,0-.51-.21,2.2,2.2,0,0,0-.67-.1,1.54,1.54,0,0,0-1.44.78,4.91,4.91,0,0,0-.44,2.33q0,3.18,1.77,3.18a3.36,3.36,0,0,0,.92-.12v-2.41h-.92c-.17,0-.26-.15-.26-.43v-.24c0-.29.09-.44.26-.44h1.84C159.7,438,159.82,438.14,159.82,438.4Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.38,442.41v-7.85c0-.2.18-.3.53-.3h.29a.79.79,0,0,1,.32.06.37.37,0,0,1,.19.2l2.61,5a7.34,7.34,0,0,1,.33.81l.06,0a4.14,4.14,0,0,1-.09-.84v-4.86c0-.2.17-.3.53-.3h.17c.36,0,.53.1.53.3v7.85c0,.2-.17.3-.53.3h-.24c-.26,0-.42-.08-.49-.23l-2.7-5.12a4.53,4.53,0,0,1-.31-.76l-.06,0a4.25,4.25,0,0,1,.1.81v5c0,.2-.18.3-.53.3h-.18C161.56,442.71,161.38,442.61,161.38,442.41Z",
    style: {
      fill: "#455a64"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottom--inject-17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--bottom--inject-17"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "235.57 390.74 232.51 389.08 235.62 388.33 235.57 390.74",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.41,395.38s37.44-15.36,37.8-12.85a3.7,3.7,0,0,1-.07,1.5,1.47,1.47,0,0,0,.1-.13l-.85,4.63a11,11,0,0,1-5.82,2.21c0-.23,0-1.62.05-2.41a19.75,19.75,0,0,0-3.31,1.61c-2.42,1.49-4,4.18-6.66,7.28-1.91,2.26-5.21,3.22-10.05,3.74-5.22.55-9.75-.62-11-2.07C203.62,397.73,204.21,395.69,204.41,395.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.46,394.55c.37-.36,1.74-1.77,3.57-3.29a69.51,69.51,0,0,1,5.48-4.35,20.34,20.34,0,0,0,2.72-2.1,27.18,27.18,0,0,0,1.91-2.1,39.59,39.59,0,0,0,4.29-6.56,10.55,10.55,0,0,0,1.31-5.67,130.19,130.19,0,0,0-1-16.51l17.74.29c-.61,2.8-1,7.58-1.36,10.78-.59,4.85-.76,5.93,1,10.86.5,1.45,1.28,2.86,1.3,4.4,0,2.49-2,4.57-4.23,5.71-1.84.95-3.93,1.3-5.72,2.32a18.09,18.09,0,0,0-4.75,4.36c-1.3,1.55-2.36,3.39-4.14,4.45a16.32,16.32,0,0,1-6.08,1.87,32.27,32.27,0,0,1-8.07.11C205.58,398.68,202.78,397.17,205.46,394.55Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.11,387.46a6.88,6.88,0,0,0-5.69-.74c-2.79,2.06-5.11,3.9-6.75,5.19-2,1.56-3.72,3-3.72,4.85,0,2.93,11.28,4.23,17.7,1.69a7.9,7.9,0,0,0,4.61-3.77S225.48,390.55,220.11,387.46ZM242,377.73a31.29,31.29,0,0,1-1.23-2.9c-2.24,1.12-6.27,6.5-4.72,12.12a8.39,8.39,0,0,0,5.68-3.58A5.32,5.32,0,0,0,242,377.73Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.36,381.47c-1,1.68.31,8,.07,12.5-.21,4.09-1.3,11.21-.05,15.25,1.49,4.79,4.52,10.34,10.14,5.86,3.49-2.78,5.49-6.37,6-12.26.33-4.09-1.31-9.75-2.71-14.76-1.63-5.86-2.26-9-2.26-9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.91,351.31c.4,9.54-.71,16.24-.77,22.34a42.47,42.47,0,0,0,.87,8.25c.8,3.9,2.16,9.32,2.73,11.84.8,3.53,1.41,5.75.19,9.71a5.06,5.06,0,0,1-.4.89c-1.71,3.27-6,5.73-7.42,5.34a2.39,2.39,0,0,1-2.44.85,3.9,3.9,0,0,1-.46-.12,2.58,2.58,0,0,1-.46-.18,4.75,4.75,0,0,1-2.31-3c-.08-.27-.16-.56-.22-.86a30.24,30.24,0,0,1-.18-10c.11-2.22,0-5-.22-8.62s-1.05-14.81-2.29-20.18c-.92-3.75-2.07-8.45-3.29-13.47Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.59,398.33c-3.42-1.5-13.32-1.71-14.9,3.11,0,4.53-.07,7.61,2.8,11.56,3.81,5.25,8.78-.32,10.68-3.85S285.05,400.78,284.59,398.33Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268,226.76c4.83,8.64,8.72,15.93,10,38.77,1.42,25.78,1.21,35.59,1.33,38.71s2.13,8.81,3.83,24.13-.09,52.46-.09,52.46-1.2,2.5-7.06,3.07a15,15,0,0,1-8.58-1.37l-12.5-55.7c-2.92-13.05-7.22-38.9-7.22-38.9L245,309.66s1.71,8.44.16,21.9-4.43,39.2-4.43,39.2a19,19,0,0,1-8,2.9,13.62,13.62,0,0,1-8.74-1.89s-5.23-53.33-5.34-68.57-1.08-57.92,5.69-75.85Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.45,249.21c2.35,6.27,10.74,10.62,14.42,11.47l3.77,26.93-.6,22.05,2.64-21.73-4.33-32.19S233.16,255.09,227.45,249.21Zm34.83-3.33c.62,2.47,1.19,5,1.79,7.44s1.17,5,1.81,7.47a49.65,49.65,0,0,0-.57-7.71c-.35-2.55-.85-5.08-1.45-7.58a68.59,68.59,0,0,0-2.26-7.4,35.81,35.81,0,0,0-3.36-7c.79,2.46,1.49,4.9,2.16,7.36S261.69,243.41,262.28,245.88Zm4.3-4.79c.84,1.48,1.64,3,2.44,4.49l2.38,4.6a20.48,20.48,0,0,0-1.22-5.11A32.54,32.54,0,0,0,268,240.3a36.26,36.26,0,0,0-2.87-4.38,27.48,27.48,0,0,0-3.51-3.89c.77,1.58,1.62,3.09,2.46,4.58S265.77,239.59,266.58,241.09Zm-3.32,69.61c-1.53-7.88-2.63-15.86-3.72-23.84s-2.13-16-3.3-23.95c.55,8,1.19,16.08,2,24.11s1.88,16,3.38,24,3.23,15.79,4.95,23.67,3.49,15.74,5.39,23.58q-1.92-11.94-4.15-23.83C266.39,326.51,264.83,318.57,263.26,310.7Zm-36.87-26.55,1.16-21c-1,6.95-1.82,13.94-2.42,20.94s-1.13,14-1.1,21.1c.29,7.07.88,14,1.51,21s1.37,14,2.25,21q-.37-10.55-1-21.05l-.61-10.51c-.2-3.5-.44-7-.53-10.48s.1-7,.23-10.47S226.22,287.65,226.39,284.15Z",
    style: {
      fill: "#263238"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M217,188.46c-4,4-13.48,13-13.48,13s-5.15-5.52-7.31-7.9a51.35,51.35,0,0,1-6.93-8.93c-1.41-2.39-2-4.58-2.94-6.29a29.42,29.42,0,0,0-3.09-4.13c-1.13-1.38-2.31-2.73-3.44-4.12-.29-.35-.71-.19-1,.08a2.55,2.55,0,0,0-.76,2,5.77,5.77,0,0,0,.64,2.14,15.84,15.84,0,0,0,1,1.76c.38.59,1.31,2,.33,2.43h0c-.71.33-2.09-.21-2.81-.39-4-1-8.3-4.75-10.07-6.16s-2.55-1-2.76,0a2.73,2.73,0,0,0,.6,1.6c-.95-.83-1.87-1.38-2.64-1.17-1,.27-.29,1.62.05,2.18s.9,1.5.9,1.5c-.43.06-.72.74-.78,1a1.77,1.77,0,0,0,.09.91,11.32,11.32,0,0,0,3.16,4.17c-1.07-.58-1.45-1-2-1.09a.81.81,0,0,0-.95.42c-.21.44,1.08,2.05,1.41,2.41,2.64,3,2.7,2.79,4.75,4a26.48,26.48,0,0,0,3.88,1.75c.88.27,2.37.75,3.72,1.09,3.45.87,6.32,2.94,7,4.17,9.1,15.62,13.12,24.07,19.73,25.84,3.65,1,7.3-1.37,12.67-6,6.45-5.62,16.71-17,16.71-17l4.15-21.2C228.93,177,225.21,180.24,217,188.46Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.73,182.21a22,22,0,0,0,2.8,1.73c1,.53,2,.95,3,1.49a12.23,12.23,0,0,1-3.15-1.13A8.18,8.18,0,0,1,165.73,182.21Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.67,187.74a2.74,2.74,0,0,0,0-.64,4.18,4.18,0,0,0-.4-1.19,5.53,5.53,0,0,0-1.57-1.89,5.36,5.36,0,0,0-5.18-.68s-.12.18,0,.18a7.38,7.38,0,0,1,4.82,1.06,5.61,5.61,0,0,1,2,3.79c0,.13.16.11.2,0A2,2,0,0,0,184.67,187.74Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174,180a37,37,0,0,1-4.6-2.94c-1.41-1-2.75-2.09-4.1-3.17,0,0,0,0,0,0a21.49,21.49,0,0,0,4.21,3.69,30.48,30.48,0,0,0,4.51,2.41S174,180,174,180Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.37,183a37,37,0,0,1-4.6-2.94c-.56-.4-1.12-.81-1.66-1.23a19.88,19.88,0,0,1-1.59-1.29l-.45-.43a4.29,4.29,0,0,0-.59-.54,2.34,2.34,0,0,0-.76-.33s-.07,0-.06,0a2.71,2.71,0,0,1,.87.58,5.79,5.79,0,0,1,.48.51c.14.16.28.3.43.45q.69.69,1.44,1.32c.63.53,1.28,1,2,1.49a31,31,0,0,0,4.51,2.41S173.39,183,173.37,183Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.51,209.36a15.52,15.52,0,0,0-6-7.86l1.38-1.32C209.07,204.37,209.28,206.83,209.51,209.36Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Head--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M255.79,170.86a14.73,14.73,0,0,1-8.69,2.29,2.31,2.31,0,0,1-.74-.14,2.51,2.51,0,0,1-1.07-1.09q-3.34-5.25-7.13-10.22c-2.36-3.1-5.06-6-6.92-9.44a8.72,8.72,0,0,1-.05-8.27,8.69,8.69,0,0,1,1.09-1.6,7.65,7.65,0,0,0,1-1c.32-.55-.09-2,0-2.78a8.42,8.42,0,0,1,.88-2.72,7.68,7.68,0,0,1,4.06-3.63c1.07-.4,2.22-.54,3.31-.91,2.32-.79,3.93-2.78,6.14-3.66a10.93,10.93,0,0,1,6.44-.55c2.42.59,3.87,3,6.38,3.13,1.28.07,2.55-.2,3.83-.14a7.33,7.33,0,0,1,6.61,5.89c.21,1.25.09,2.54.2,3.81a4.67,4.67,0,0,0,1.52,3.38,2.3,2.3,0,0,0,3.33-.43,2.77,2.77,0,0,1-3.68,3.64,9,9,0,0,1,1,3.63c0,2.35-1.93,4.34-4.1,5.22a29.7,29.7,0,0,0-3.7,1.35c-1.88,1.07-2.37,3.11-3.46,4.82s-2.07,3.37-3,5.12c-.73,1.39-1,2.73-2.29,3.69C256.4,170.45,256.1,170.66,255.79,170.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262,177c-2.45-.55-2.76-1.1-2.93-3.29l-.19-2.18a9.67,9.67,0,0,0,7.07-2.44c2.89-2.65,4.33-7.81,3.9-13.3-.29-3.65-1.28-5.34-1.25-6.16.19-4.91-.22-5.77-1.43-8.27-2.15-4-7.36-5.31-9.47-.92-6.52-4.81-13.41,1.92-12.93,9.47,1,6.21-.88,6.57-2.1,6.65-1.9-3.84-5.92-3.68-7.55-1.12-1.47,2.32-1.33,5.81,1.71,8.93s6.12.94,6.14.31c0,0,.41,6.61.52,8.29s0,3-.68,3.14a7.93,7.93,0,0,0-1,8.72C249,187.34,262.06,178.25,262,177Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.24,147.39l-3.69-.89a1.84,1.84,0,0,1,2.23-1.43A2,2,0,0,1,266.24,147.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.3,148.68l3.47-1.63a1.84,1.84,0,0,0-2.5-1A2,2,0,0,0,250.3,148.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.35,161.37l-4.87-1.19a2.4,2.4,0,0,0,1.75,3A2.63,2.63,0,0,0,260.35,161.37Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.53,161.57A5.62,5.62,0,0,1,259,163a2.57,2.57,0,0,1-1.77.22,2.38,2.38,0,0,1-1.77-1.79A5.65,5.65,0,0,1,256.53,161.57Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.7,151a1.59,1.59,0,0,0,1.54,1.58,1.5,1.5,0,0,0,1.56-1.49,1.59,1.59,0,0,0-1.55-1.57A1.48,1.48,0,0,0,262.7,151Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.58,152.07a1.62,1.62,0,0,0,1.58,1.61,1.52,1.52,0,0,0,1.59-1.52,1.64,1.64,0,0,0-1.58-1.61A1.54,1.54,0,0,0,251.58,152.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.91,171.57c-6-.15-11.91-1.37-13.64-4.93a6.15,6.15,0,0,0,3.79,4.86,21.64,21.64,0,0,0,10,1.83Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "264.07 156.16 258.7 158.59 257.23 148.28 264.07 156.16",
    style: {
      fill: "#f0997a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chest--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M225.39,217c-.1-2.3-.09-3.69-.37-7a12.92,12.92,0,0,1-4.72-8.44c-.54-4.42.58-7.92,6.66-14.59,5.46-6,9.93-10.48,9.93-10.48l6-.39s-2.32,4.71-.64,8.12c9-.68,16.67-4.54,19.82-7.23l9.47,1.1a26.33,26.33,0,0,1,5.21,17.48c-.3,4.39-2.32,9.87-3.92,15.62-1.54,5.58-3.14,11-.61,18.94a107.45,107.45,0,0,1,3.5,13.91s-13,6.86-33.68,4.69c-14.82-1.55-21.11-7.67-21.11-7.67l3.85-17.57A26.65,26.65,0,0,0,225.39,217Z",
    style: {
      fill: "#3E8804"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.1,208a11.51,11.51,0,0,1-10.19,7.25,12.15,12.15,0,0,1-11-5.29s1.24,8.39,11.19,7.3S259.1,208,259.1,208Z",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arn--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M271.57,178.14s1.22.05,3.18.21c4.15.34,6.08,1.26,8.09,2.64,1.78,1.22,2.86,2.91,4.74,6.18,2.77,4.83,14.5,23.6,14.5,23.6s-3.7,15.91-8.58,14.19c-4.05-1.44-18.94-24-18.94-24A27.78,27.78,0,0,1,271.57,178.14Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296,201a17.81,17.81,0,0,0-5.16,13.51l9.31-6.83Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.67,182.79s0-.47.82-.93,1.39-.63,2.28-1.13,2.27-1.54,2.07-2.47-2.33-.53-3.94.11a7.77,7.77,0,0,1-4.78.69c-2.24-.31-4.92-.24-6.47,1.69Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.2,187.19a32.46,32.46,0,0,1,4.5-2.56,14.8,14.8,0,0,0,3.08-2.52c1-1,2.46-2.09,2.43-2.6s-.83-1-1.79-.6c0,0,.47-.88,1-1.68s1.33-1.54,1.2-2.3-1.38-.63-2.05-.06-1,.95-1,.95-.6-.55-1.73.63a7.36,7.36,0,0,0-1.15,1.61,7.21,7.21,0,0,0-2.13,1.83,13.94,13.94,0,0,0-2.29,2.05,8.23,8.23,0,0,0-3.22.39c-1.26.55-1.47.87-3.61.06-1.44-.55-3.32-1.73-5.12-2s-3.56-.32-4.88,1.64-2.25,3.46-3.69,5.4c-1.09,1.46-2.66,3.12-8.05,9.56-4.18,5-5,5.72-6.95,8.31a17.62,17.62,0,0,0-3.9,10.63c-.15,5.54.79,8.56,3.15,9.28,5,1.54,11.07-4.81,12.69-8s6.36-15.27,8.1-19.44,3.92-7.33,5-7.76a25.49,25.49,0,0,1,6.08-1.2C328.05,188.47,328.11,188.81,330.2,187.19Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.65,180.75a9.83,9.83,0,0,0-1.92,2.46c-.6.87-1.2,1.74-1.83,2.58s-1.23,1.71-1.88,2.54-1.65,1.87-2.31,2.69c.58-.88,1.55-2,2.15-2.81s1.22-1.71,1.83-2.57l1.84-2.56.92-1.28A3.77,3.77,0,0,1,314.65,180.75Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.42,178.91a8.9,8.9,0,0,0-1.11.9c-.34.32-.68.67-1,1l-.05.06-.09,0c-.23.06-.48.15-.72.24a6.33,6.33,0,0,0-.68.36,4.55,4.55,0,0,0-1.16,1l-.09.09h-.1a4,4,0,0,0-.59,0,5.58,5.58,0,0,0-.59.09,5.69,5.69,0,0,0-.59.16,5.83,5.83,0,0,0-.58.23,3.63,3.63,0,0,1,1.08-.67,4.48,4.48,0,0,1,.62-.2,4.38,4.38,0,0,1,.66-.09l-.19.09a4.07,4.07,0,0,1,1.25-1.16,4.55,4.55,0,0,1,.76-.39,4.41,4.41,0,0,1,.83-.23l-.13.07a7.91,7.91,0,0,1,1.14-.94A4.83,4.83,0,0,1,338.42,178.91Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.56,175.82a3.6,3.6,0,0,0-.39.72,4.09,4.09,0,0,0-.24.75v.05l-.07,0a6.82,6.82,0,0,0-1.19,1.21,4.47,4.47,0,0,0-.74,1.48l-.05.16-.17,0a6.54,6.54,0,0,0-.9.27,8.72,8.72,0,0,0-.87.42,9.8,9.8,0,0,0-.83.53c-.28.19-.53.41-.8.62a7,7,0,0,1,.64-.8,6.24,6.24,0,0,1,.77-.68,5.75,5.75,0,0,1,.9-.53,3.88,3.88,0,0,1,1-.35l-.22.19a3.64,3.64,0,0,1,.34-.88,5,5,0,0,1,.52-.78,6.65,6.65,0,0,1,.65-.65,4.49,4.49,0,0,1,.76-.53l-.07.1a3.44,3.44,0,0,1,.4-.76A2.76,2.76,0,0,1,337.56,175.82Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.72,183a4,4,0,0,1-1.81.26,5.65,5.65,0,0,1-1.78-.42c.31,0,.61,0,.91.07l.89.08A13.35,13.35,0,0,0,328.72,183Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.31,180.9a7.5,7.5,0,0,0-3.11.9,5.94,5.94,0,0,0-1.27,1,12.35,12.35,0,0,0-1.07,1.27,4.46,4.46,0,0,1,.75-1.55,4.32,4.32,0,0,1,1.32-1.16A4.42,4.42,0,0,1,320.31,180.9Z",
    style: {
      fill: "#f0997a"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--UI--inject-17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--ui--inject-17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Box--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M180.7,124.41,146.75,144a2.79,2.79,0,0,0-1.25,2.17v31.47a2.75,2.75,0,0,0,1.26,2.16l2.39,1.35a2.78,2.78,0,0,0,2.51,0l34-19.58a2.77,2.77,0,0,0,1.25-2.17V127.91a2.7,2.7,0,0,0-1.26-2.15l-2.39-1.36A2.81,2.81,0,0,0,180.7,124.41Z",
    style: {
      fill: "#3E8804"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.66,181.13a2.87,2.87,0,0,1-2.51,0l-2.39-1.36a2.75,2.75,0,0,1-1.26-2.16V146.16a2.59,2.59,0,0,1,.4-1.27l4.88,2.82a2.5,2.5,0,0,0-.37,1.23v31.47C150.41,181.14,150.92,181.56,151.66,181.13Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M186.85,127.69c-.1-.63-.62-.86-1.24-.5l-34,19.58a2.58,2.58,0,0,0-.88.94l-4.89-2.82a2.59,2.59,0,0,1,.87-.9l33.94-19.58a2.83,2.83,0,0,1,2.52,0l2.38,1.35A2.79,2.79,0,0,1,186.85,127.69Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M185.61,127.19l-34,19.58a2.77,2.77,0,0,0-1.25,2.17v31.47c0,.8.56,1.12,1.25.72l34-19.58a2.77,2.77,0,0,0,1.25-2.17V127.91C186.86,127.11,186.3,126.79,185.61,127.19Z",
    style: {
      fill: "#3E8804"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M170.57,142.57a.37.37,0,0,1,.44,0,.57.57,0,0,1,.19.48v12.75a16.32,16.32,0,0,1-.42,3.72,14.3,14.3,0,0,1-1.26,3.4,13.09,13.09,0,0,1-2.1,2.93,12.64,12.64,0,0,1-2.91,2.29,7.28,7.28,0,0,1-2.92,1.08,2.85,2.85,0,0,1-2.09-.52,3.7,3.7,0,0,1-1.25-1.95,11.19,11.19,0,0,1-.4-3.24V150.75a1.51,1.51,0,0,1,.18-.69,1.26,1.26,0,0,1,.44-.51l1.89-1.09a.37.37,0,0,1,.45,0,.56.56,0,0,1,.18.48v12.58a6.5,6.5,0,0,0,.26,2,2,2,0,0,0,.72,1.06,1.45,1.45,0,0,0,1.12.19,4.39,4.39,0,0,0,1.42-.55,7.09,7.09,0,0,0,1.43-1.1,6,6,0,0,0,1.13-1.49,7.52,7.52,0,0,0,.74-1.9,9.37,9.37,0,0,0,.27-2.33V144.85a1.55,1.55,0,0,1,.18-.7,1.27,1.27,0,0,1,.45-.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.35,161.56a.37.37,0,0,1-.44,0,.54.54,0,0,1-.19-.48V141a1.45,1.45,0,0,1,.19-.7,1.22,1.22,0,0,1,.44-.5l1.89-1.09a.37.37,0,0,1,.44,0,.59.59,0,0,1,.19.48v20.08a1.57,1.57,0,0,1-.19.7,1.15,1.15,0,0,1-.44.5Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--UX--inject-17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--ux--inject-17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--box--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M318.82,124.41,352.77,144a2.79,2.79,0,0,1,1.25,2.17v31.47a2.72,2.72,0,0,1-1.26,2.16l-2.38,1.35a2.8,2.8,0,0,1-2.52,0l-33.94-19.58a2.75,2.75,0,0,1-1.26-2.17V127.91a2.73,2.73,0,0,1,1.26-2.15l2.39-1.36A2.81,2.81,0,0,1,318.82,124.41Z",
    style: {
      fill: "#3E8804"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.86,181.13a2.89,2.89,0,0,0,2.52,0l2.38-1.36a2.72,2.72,0,0,0,1.26-2.16V146.16a2.57,2.57,0,0,0-.39-1.27l-4.88,2.82a2.5,2.5,0,0,1,.37,1.23v31.47C349.12,181.14,348.6,181.56,347.86,181.13Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M312.68,127.69c.1-.63.61-.86,1.24-.5l33.94,19.58a2.6,2.6,0,0,1,.89.94l4.88-2.82a2.48,2.48,0,0,0-.86-.9l-33.95-19.58a2.81,2.81,0,0,0-2.51,0l-2.39,1.35A2.78,2.78,0,0,0,312.68,127.69Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M313.92,127.19l33.94,19.58a2.75,2.75,0,0,1,1.26,2.17v31.47c0,.8-.56,1.12-1.26.72l-33.94-19.58a2.75,2.75,0,0,1-1.26-2.17V127.91C312.66,127.11,313.22,126.79,313.92,127.19Z",
    style: {
      fill: "#3E8804"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M329.19,143.19a1.1,1.1,0,0,1,.44.5,1.45,1.45,0,0,1,.19.7v12.74a10.8,10.8,0,0,1-.42,3.24,3.79,3.79,0,0,1-1.26,1.94,2.87,2.87,0,0,1-2.1.52,7.45,7.45,0,0,1-2.91-1.08,12.55,12.55,0,0,1-2.92-2.29,13,13,0,0,1-2.09-2.93,13.86,13.86,0,0,1-1.25-3.4,16.74,16.74,0,0,1-.41-3.71V136.68a.6.6,0,0,1,.19-.49.37.37,0,0,1,.44,0l1.89,1.09a1.27,1.27,0,0,1,.45.51,1.51,1.51,0,0,1,.18.69v12.59a9.8,9.8,0,0,0,.26,2.32,7.8,7.8,0,0,0,.72,1.9,6.34,6.34,0,0,0,1.12,1.48,7.06,7.06,0,0,0,1.42,1.09,4.63,4.63,0,0,0,1.43.56,1.47,1.47,0,0,0,1.13-.19,2,2,0,0,0,.74-1.05,6.12,6.12,0,0,0,.27-2V142.58a.59.59,0,0,1,.18-.48.39.39,0,0,1,.45,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.9,173.43a1.63,1.63,0,0,1-.68-.7c-.14-.29-.24-.5-.3-.64l-3.71-9-3.68,4.74a2.88,2.88,0,0,1-.3.29c-.14.13-.37.1-.68-.08l-2-1.13a1.15,1.15,0,0,1-.44-.5,1.57,1.57,0,0,1-.19-.7.82.82,0,0,1,.07-.3l5.34-6.83-5.1-12.43a1.23,1.23,0,0,1-.07-.38.56.56,0,0,1,.18-.48.39.39,0,0,1,.45,0l1.95,1.13a1.6,1.6,0,0,1,.68.71c.14.28.24.5.3.64l3.52,8.59,3.5-4.54a2.88,2.88,0,0,1,.3-.29c.14-.13.37-.1.68.08l2,1.13a1.16,1.16,0,0,1,.44.5,1.57,1.57,0,0,1,.19.7.67.67,0,0,1-.08.3l-5.15,6.63,5.29,12.84a1.29,1.29,0,0,1,.08.39.59.59,0,0,1-.19.48.38.38,0,0,1-.44,0Z",
    style: {
      fill: "#fff"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUiUx);
export default __webpack_public_path__ + "static/media/ui-ux.5ea6155fc17e577933a723444678dc64.svg";
export { ForwardRef as ReactComponent };